{
  "A1": "A1",
  "A2": "A2",
  "accents_and_special_characters": "Accents et caractères spéciaux",
  "account": "Account",
  "activity": "Activité",
  "actor": "Acteur {{number}}",
  "actor_2": "Acteur 2",
  "actor_name": "Nom de l'acteur",
  "actor_voice": "Voix d'acteur",
  "add_alternatives": "Ajouter des alternatives",
  "add_another_reply": "Ajouter une autre réponse",
  "add_courses": "Ajouter des cours",
  "add_answer": "Ajouter une réponse",
  "add_image": "Ajouter une image",
  "add_image_desc": "Ajoutez une image à votre exercice!",
  "add_link": "Ajouter un lien",
  "add_link_desc": "Ajoutez un lien à votre exercice!",
  "all_steps_complete": "Toutes les étapes sont terminées",
  "alternative_versions": "Versions alternatives",
  "archive_recording_error": "Un problème est survenu lors de l'archivage de l'enregistrement",
  "assign": "Attribuer",
  "attach_file": "Joindre un fichier",
  "bot_not_found": "Chatbot introuvable",
  "bot_not_found_desc": "Nous n'avons pas trouvé ce chatbot. Il a peut-être été supprimé ou rendu privé.",
  "categories": "Catégories",
  "chart": "Graphique",
  "choose_length_of_roleplay": "Choisissez la longueur du scénario",
  "clear": "Effacer",
  "close_pdf": "Fermer le PDF",
  "comma_seperated_domains": "Domaines séparés par des virgules",
  "community": "Communauté",
  "datetime": "Date et heure",
  "days": "jours",
  "days_late": "{{count}} jours de retard",
  "discussion": "Discussion",
  "download_error": "Un problème est survenu lors du téléchargement du fichier",
  "editor_mode": "Mode éditeur",
  "email_notifications": "Notifications par e-mail",
  "enter_linguistic_goal": "Entrez votre objectif linguistique",
  "add_new": "Ajouter un nouveau",
  "add_phrase": "Ajouter une phrase",
  "add_phrase_desc": "Ajouter une nouvelle expression en {{language}} pour que les gens apprennent",
  "add_phrases": "Ajouter des phrases",
  "add_phrases_to_enable_exercise": "Ajouter des phrases pour permettre l'exercice",
  "add_question": "Ajouter une question",
  "add_question_desc": "Posez une question de compréhension, la question peut avoir plusieurs réponses correctes.",
  "add_review": "Ajouter un commentaire",
  "add_review_desc": "Partagez vos réflexions ci-dessous",
  "add_script": "Ajouter Un Script",
  "add_section": "Ajouter une section",
  "add_substitution": "Ajouter une substitution",
  "add_substitution_desc": "Avec les substitutions, vous pouvez voir à la place que «ce qui» est étendu à «ce qui est» - vous permettant un meilleur contrôle sur la façon dont vous répondez au message de l'utilisateur!",
  "add_topic": "Ajouter un sujet",
  "add_topic_desc": "Les sujets sont des regroupements logiques de déclencheurs. Lorsqu'un utilisateur se trouve dans un sujet, il ne peut faire correspondre que les déclencheurs qui appartiennent à ce sujet.",
  "add_topic_to_section": "Ajouter un sujet à la section {{sectionId}}",
  "add_trigger": "Ajouter un déclencheur",
  "add_trigger_desc": "Un déclencheur est une ligne de texte utilisée pour faire correspondre le message de l'utilisateur.",
  "add_variable": "Ajouter une variable",
  "add_variable_desc": "Les variables du chatbot sont des informations décrivant votre chatbot, telles que son nom et son âge. Avec les variables de chatbot, nous pouvons écrire des réponses dans lesquelles le chatbot peut dire à l'utilisateur quelque chose sur lui-même.",
  "add_voice": "Ajouter une voix",
  "all": "Tout",
  "all_topics_completed": "Tous les sujets terminés",
  "alternatives": "Alternatives",
  "alternatives_desc": "Une liste de mots ou d'expressions qui peuvent être réutilisés dans votre chatbot.",
  "alternatives_name": "Nom",
  "alternatives_value": "Liste de mots (séparés par des virgules)",
  "answer": "Réponse",
  "new_answer_placeholder": "Écrivez votre réponse ici",
  "answer_message_100": "Parfait, excellent travail",
  "answer_message_90": "Vous allez y arriver, continuez vos efforts",
  "answer_message_95": " Vous n'étiez pas loin, vous y êtes presque",
  "answer_message_wrong": "Ce n'était pas tout à fait ça",
  "attempt": "Essai",
  "attempt_messages": "Essai d'exercice",
  "attempt_table": "Tentatives",
  "auto_translate": "Traduire automatiquement",
  "auto_translate_phrase": "Traduction automatique de la phrase",
  "avg_pronunciation_score": "Avg Pronunciation Score",
  "average_pronunciation_score_tooltip": "Average pronunciation score is",
  "B1": "B1",
  "B2": "B2 ",
  "back": "Retour",
  "back_to_course": "Retour aux cours",
  "blog": "Blog",
  "bot": "Chatbot",
  "bot-listen-and-speak": "Chatbot - Écouter et Parler",
  "all_modes": "Tous les modes",
  "bot_information": "Informations sur le chatbot",
  "bot_intro_message": "Message d'introduction du chatbot",
  "bot_intro_message_helper_text": "Laissez vide si vous voulez que l'élève commence la conversation.",
  "bot_name": "Nom du chatbot",
  "bot_reply": "Réponse de Chatbot",
  "bot_settings": "Paramètres du chatbot",
  "bot_title": "Titre du chatbot",
  "bot_voice": "Voix de chatbot",
  "bots": "Chatbots",
  "bots_not_found_desc": "Créez le premier chatbot aujourd'hui",
  "bots_not_found_title": "Aucun chatbot trouvé",
  "C1": "C1",
  "C2": "C2",
  "cancel": "Annuler",
  "card_A1": "A1",
  "card_A2": "A2",
  "card_B1": "B1",
  "card_B2": "B2",
  "card_C1": "C1",
  "card_C2": "C2",
  "change_app_colors": "Changer les couleurs des applications",
  "change_language": "Changer de langue",
  "chatbot_exercise_desc": "Discutez avec un robot pour simuler une conversation sur un sujet",
  "chatbots": "Robots de conversation",
  "choose_avatar": "Choisissez un Nuala",
  "choose_from_file": "Choisissez dans le fichier",
  "classroom_code": "Code de classe",
  "classroom_code_label": "Entrez le code de la classe",
  "classroom_code_not_valid": "Code de classe non valide",
  "classroom_created": "Création de la classe",
  "classroom_deleted": "Classe supprimée",
  "classroom_information": "Informations sur la classe",
  "classroom_name": "Nom de la classe",
  "classroom_not_found": "Classe introuvable",
  "classroom_not_found_desc": "Cette classe a peut-être été supprimée",
  "classroom_load_error": "Impossible de charger cette classe",
  "classroom_load_error_desc": "Une erreur s'est produite lors du chargement de cette classe. Veuillez réessayer.",
  "classroom_settings": "Paramètres de la classe",
  "classrooms": "Classes",
  "classrooms_not_found_desc": "Créez la première classe aujourd'hui",
  "classrooms_not_found_title": "Aucune classe trouvée",
  "collaborators": "Collaborateurs",
  "color": "Couleur",
  "community_templates": "Modèles de communauté",
  "completed": "Terminé",
  "completed_icon": "Icône terminée",
  "completion": "Achèvement",
  "completions": "Achèvements",
  "confirmation": "Confirmation",
  "contact_form": "Formulaire de contact",
  "continue": "Continuer",
  "continue_exercise": "Continuer l'exercice",
  "continue_learning": "Continuez à apprendre",
  "continue_teaching": "Continuez à enseigner",
  "copied": "Copié",
  "copy_to_clipboard": "Copier dans le presse-papier",
  "correct": "Correct",
  "correct_answer": "Bonne réponse",
  "correct_answer_percentage": "Correct Answer Percentage",
  "course": "Cours",
  "course_code": "Code de cours",
  "course_code_label": "Entrez le code du cours",
  "course_code_not_valid": "Code de cours non valide",
  "course_created": "Cours créé",
  "course_deleted": "Cours supprimé",
  "course_information": "Informations sur les cours",
  "course_name": "Nom du cours",
  "course_not_found": "Cours non trouvé",
  "course_not_found_desc": "Ce cours a peut-être été supprimé",
  "course_outline": "Plan de cours",
  "course_progress": "Progression du cours",
  "course_settings": "Paramètres du cours",
  "courses": "Cours",
  "courses_not_found_desc": "Créez le premier cours aujourd'hui",
  "courses_not_found_title": "Aucun cours trouvé",
  "create": "Créer",
  "create_bot": "Créer un chatbot",
  "create_classroom": "Créer une classe",
  "create_course": "Créer un cours",
  "create_course_section": "Créer une section de cours",
  "create_course_section_desc": "C'est à vous de structurer le cours, les exemples de structures sont 'Débutant, Intermédiaire, Avancé' ou 'Semaine 1, Semaine 2, Semaine 3'",
  "create_topic": "Créer un sujet",
  "created_courses": "Cours créés",
  "creation_visibility": "Le contenu public peut être utilisé comme point de départ pour d'autres créations d'éducateurs.",
  "creator": "Créateur",
  "customization": "Personnalisation",
  "dark_theme": "Thème sombre",
  "dark_theme_desc": "Assombrit les surfaces claires de la page, créant une expérience idéale pour la nuit.",
  "delete_bot": "Supprimer le chatbot",
  "delete_bot_confirmation": "Voulez-vous vraiment supprimer ce chatbot?",
  "delete_classroom": "Supprimer la classe",
  "delete_classroom_confirmation": "Voulez-vous vraiment supprimer cette classe?",
  "delete_course": "Supprimer le cours",
  "delete_course_confirmation": "Voulez-vous vraiment supprimer ce cours?",
  "delete_phrase": "Supprimer la phrase",
  "delete_phrase_confirmation": "Voulez-vous vraiment supprimer cette phrase?",
  "delete_review": "Supprimer la révision",
  "delete_review_confirmation": "Voulez-vous vraiment supprimer votre avis?",
  "delete_roleplay": "Supprimer le jeu de rôle",
  "delete_roleplay_confirmation": "Voulez-vous vraiment supprimer ce jeu de rôle?",
  "delete_section": "Supprimer la section",
  "delete_section_confirmation": "Voulez-vous vraiment supprimer cette section?",
  "delete_topic": "Supprimer le sujet",
  "delete_topic_confirmation": "Voulez-vous vraiment supprimer ce sujet?",
  "description": "La description",
  "difficulty": "Difficulté",
  "difficulties": "Difficultés",
  "disable": "Désactiver",
  "disabled": "désactivé",
  "display": "Afficher",
  "display_classroom_code": "Display classroom code",
  "download_csv_file": "Télécharger",
  "drop_csv_file_or_click_to_upload": "Déposez le fichier CSV ou cliquez pour télécharger.",
  "edit": "Éditer",
  "edit_bot": "Modifier le chatbot",
  "edit_discussion": "Modifier la discussion",
  "edit_roleplay": "Modifier le jeu de rôle",
  "email": "Email",
  "enable": "Activer",
  "enabled": "Activé",
  "enrolment_key": "clé d'inscription",
  "enrolment_key_not_valid": "Clé d'inscription non valide",
  "enter_private_key": "Entrez la clé privée",
  "error_generating_discussion": "Un problème est survenu lors de la génération de la discussion",
  "exercise": "Exercice",
  "exercise_complete": "Exercice terminé",
  "exercise_completed_icon": "{{name}} terminé {{counter}} fois",
  "exercise_completion": "a terminé l'exercice de {{exercise}} '{{id}}'",
  "exercise_in_progress": "a commencé l'exercice de {{exercise}} '{{id}}'",
  "exercise_progress_bar": "Exercise progress bar",
  "exercise_info": "Informations sur l'exercice",
  "exercise_no_longer_available": "Cet exercice n'est plus disponible",
  "exercises": "Des exercices",
  "exercises_completed": "Exercices terminés",
  "exercises_completed_icon": "{{name}} terminé {{counter}} fois",
  "exit": "Quitter",
  "expand": "Développer",
  "fill_in_contact_form": "Remplissez le formulaire ci-dessous",
  "find_bot": "Trouver un chatbot",
  "find_classroom": "Trouver une classe",
  "find_course": "Rechercher un cours",
  "find_roleplay": "Trouver un jeu de rôle",
  "finish": "terminer",
  "finish_exercise": "Terminer L'exercice",
  "for_lang": "je parle",
  "formatting_options": "Options de formatage",
  "from": "De",
  "fullscreen": "Plein écran",
  "generate_definitions_info": "Générez des définitions pour les expressions de cette liste.",
  "generating": "Génération en cours",
  "get_started": "Commencer",
  "go_back": "Retourner",
  "go_back_to_topic": "Revenir au Sujet",
  "go_to": "Go to",
  "go_to_settings": "Aller aux paramètres",
  "group_information_form_title": "Parlez-nous de votre groupe",
  "group_member_limit": "Limite de membres du groupe",
  "group_name": "Nom du groupe",
  "group_picture": "Image du groupe",
  "group_subscription_form_title": "Configurez l'abonnement du groupe",
  "help": "Aide",
  "hidden": "Masqué",
  "hide": "Masquer",
  "hide_bot": "Masquer le chatbot",
  "hide_chatbots_exercise": "Masquer les chatbots",
  "hide_listening_exercise": "Masquer l'exercice d'écoute",
  "hide_menu": "Masquer le menu",
  "hide_options": "Masquer les options",
  "hide_pronunciation_exercise": "Masquer l'exercice de prononciation",
  "hide_roleplay": "Masquer le jeu de rôle",
  "hide_roleplays_exercise": "Masquer les jeux de rôle",
  "hide_section": "Section cachée",
  "hide_topic": "Masquer le sujet",
  "hide_translation_exercise": "Masquer l'exercice de traduction",
  "hide_word_bank": "Masquer la banque de mots",
  "home": "Accueil",
  "how_to_join_find_button": "Repérez le bouton {{button}} et cliquez dessus.",
  "how_to_join_get_ready": "Préparez-vous à jouer.",
  "how_to_join_intro": "Pour rejoindre la partie, suivez ces étapes :",
  "how_to_join_open_classroom": "Ouvrez la classe {{classroom}} ou scannez son QR code ci-dessous",
  "how_to_join_sign_in": "Connectez-vous à votre compte.",
  "how_to_join_title": "Comment rejoindre la partie",
  "in_game": "Dans la partie",
  "in_progress": "Continuer la lecture",
  "incorrect": "Incorrect",
  "insert_bold": "Insérez en gras",
  "insert_italic": "Insérer l'italique",
  "insert_link": "Insérer un lien",
  "insert_photo": "Insérer une photo",
  "instruction_message": "Instructions",
  "join": "S'inscrire",
  "join_classroom": "Inscrivez-vous à la classe",
  "join_code_desc": "Les étudiants peuvent utiliser le code ci-dessous pour s'inscrire",
  "join_course": "Inscrivez-vous au cours",
  "join_date": "Date d'inscription",
  "joined": "Inscrit",
  "joined_classroom": "Inscrit à cette classe",
  "joined_course": "inscrit à ce cours",
  "language": "Langue",
  "language_phrase": "Phrase en {{language}}",
  "language_translation": "Traduction en {{language}}",
  "learn": "Apprendre",
  "learn_for_speakers_of": "{{learnLang}} pour les locuteurs de {{forLang}}",
  "learn_lang": "je veux apprendre",
  "leave_classroom": "Quitter la classe",
  "leave_classroom_confirmation": "Voulez-vous vraiment supprimer cette classe?",
  "leave_course": "Quitter le cours",
  "leave_course_confirmation": "Voulez-vous vraiment quitter ce cours?",
  "left_classroom": "Classe quittée",
  "left_course": "Cours quitté",
  "lets_begin": "Commençons",
  "library": "Bibliothèque",
  "link_name": "Nom du lien",
  "link_name_helper_text": "Entrez un nom d'affichage pour votre lien",
  "link_value": "Lien URL",
  "link_value_helper_text": "Entrez l'URL de votre lien",
  "listen_to_this_phrase": "Écoutez cette expression en {{language}}",
  "listener_dialog_desc": "Choisissez une voix ci-dessous pour entendre la prononciation",
  "listening": "Écoute",
  "listening_exercise_desc": "Pouvez-vous comprendre ce qui se dit?",
  "load_more_events": "Charger plus d'événements",
  "loading": "Chargement",
  "loading_topics": "Chargement des sujets",
  "logout": "Se déconnecter",
  "manage_course": "Gérer le cours",
  "members": "Étudiants",
  "members_not_found": "Aucun membre",
  "members_not_found_desc": "Aucun membre n'a été trouvé",
  "message": "Message",
  "method": "Méthode",
  "missing_details": "Détails manquants",
  "more_definitions": "Plus de définitions",
  "more_options": "Plus d'options",
  "more_translations": "Plus de traductions",
  "my_courses": "Mes cours",
  "name": "Nom",
  "new": "Nouveau",
  "next": "Prochain",
  "next_with_progress": "Prochain ({current} sur {total})",
  "no_activity_found": "Aucune activité trouvée",
  "no_chatbot_templates": "Aucun modèle disponible",
  "no_courses_found": "Aucun cours trouvé",
  "no_phrases": "Aucune expression",
  "no_topics_available": "Aucun sujet disponible",
  "not_in_game": "Hors de la partie",
  "nualang_templates": "Modèles",
  "nudge_add_family_name_field_desc": "Ajoutez votre nom de famille afin que vos enseignants puissent vous identifier.",
  "nudge_add_family_name_profile_desc": "Ajoutez votre nom de famille à votre profil afin que vos enseignants puissent vous identifier.",
  "nudge_add_family_name_title": "Ajoutez votre nom de famille",
  "on": "le",
  "only_available_on_chrome": "Disponible uniquement sur Chrome",
  "open_image_library": "Ouvrir la bibliothèque d'images",
  "open_in_google_sheets": "Ouvrir dans Google Sheets",
  "open_search_student_name_filters": "Open search student name filters",
  "optional": "Optionnel",
  "or_choose_from_one_of_the_following": "Ou choisissez l'une des options suivantes",
  "percentage_complete": "Percentage Complete",
  "perfect_click_finish_create_group": "Parfait ! Cliquez sur Terminer pour créer votre groupe.",
  "phrase": "Phrase",
  "phrase_group_game_in_progress_icon": "{{name}} en cours",
  "phrase_lists_error": "Un problème est survenu lors du chargement des listes d'expressions",
  "phrases": "Phrases",
  "player": "joueur",
  "players": "joueurs",
  "plays": "{{number}} Joue",
  "please_select_a_textfield": "Veuillez sélectionner un champ de texte",
  "popular_courses": "Cours populaires",
  "preview": "Aperçu",
  "preview_pdf": "Aperçu du PDF",
  "previous": "Précédent",
  "print": "Imprimer",
  "private": "Privé",
  "problem": "Il y avait un problème",
  "problem_creating": "Un problème est survenu lors de la création",
  "problem_deleting": "Un problème est survenu lors de la suppression",
  "problem_getting_reply": "Un problème est survenu lors de l'obtention de la réponse",
  "problem_loading": "Un problème est survenu lors du chargement",
  "problem_sending_contact_form": "Problème lors de l'envoi du formulaire de contact",
  "profile": "Profil",
  "profiles": "Profils",
  "progress_icon": "Icône de progression",
  "pronounce_this_phrase": "Prononcez cette phrase",
  "pronunciation": "Prononciation",
  "pronunciation_exercise_desc": "Entraînez-vous à prononcer des phrases",
  "public": "Public",
  "question": "Question",
  "new_question_placeholder": "Écrivez votre question ici",
  "questions": "Questions",
  "quit": "Quitter",
  "recommended": "Recommandé",
  "record_message": "Enregistrer le message",
  "record_unsupported": "L'enregistrement n'est pas pris en charge par ce navigateur",
  "records": "Enregistre",
  "redo_action": "Refaire",
  "refresh": "Actualiser",
  "remove": "Retirer",
  "remove_bot": "Supprimer le Chatbot",
  "remove_card": "Remove Card",
  "remove_roleplay": "Supprimer le jeu de rôle",
  "remove_classroom_member": "Remove Classroom Student",
  "remove_classroom_member_confirmation": "Are you sure you want to remove this student from your classroom",
  "remove_member": "Remove Student",
  "member_removed_from_classroom": "Student removed from classroom",
  "reply": "Réponse",
  "reply_options": "Options de réponse",
  "reply_options_are_disabled": "Les options de réponse sont désactivées",
  "reply_options_desc": "Permettre aux élèves de choisir la bonne réponse dans une liste d'options",
  "report_views": "Views",
  "required_for_private_classrooms": "Obligatoire pour les classes privées",
  "required_for_private_courses": "Requis pour les cours privés",
  "reset": "réinitialiser",
  "restart_exercise": "Redémarrer l'exercice",
  "result": "Résultat",
  "retry": "Réessayer",
  "return_to_course": "Retour au cours",
  "review_content": "Examiner le contenu",
  "review_title": "Titre du commentaire",
  "reviews": "Commentaires",
  "reviews_not_found": "Aucun commentaire",
  "reviews_not_found_desc": "Aucun commentaire n'a été trouvé",
  "roleplay": "Jeu de rôle",
  "roleplay_exercise_desc": "Simulez et répondez aux questions sur les conversations entre deux personnes",
  "roleplay_not_found": "Scénario introuvable",
  "roleplay_not_found_desc": "Nous n'avons pas trouvé ce scénario. Il a peut-être été supprimé ou rendu privé.",
  "roleplays_not_found_desc": "Essayez de modifier vos paramètres de recherche",
  "roleplay_information": "Informations sur le jeu de rôle",
  "roleplay_name": "Nom du jeu de rôle",
  "roleplay_settings": "Paramètres de jeu de rôle",
  "roleplays": "Jeux de rôle",
  "save_changes": "Sauvegarder les modifications",
  "save_definitions_error": "Un problème est survenu lors de l'enregistrement des définitions",
  "save_progress": "Enregistrer les Progrès",
  "scenarios": "Scénarios",
  "schedule": "Planifier",
  "script_not_found": "Script introuvable",
  "script_not_found_desc": "Nous n'avons pas trouvé ce script. Il a peut-être été supprimé ou rendu privé.",
  "search_images": "Rechercher des images",
  "see_more_pronunciations": "Voir plus de prononciations",
  "send": "Envoyer",
  "show_phrase_list": "Afficher la liste d'expressions",
  "show_progress": "Afficher la progression",
  "script": "Scénario",
  "search": "Search",
  "search_for_student": "Recherche élève",
  "section": "Section",
  "section_name": "Nom de la section",
  "sections_not_found": "Aucune section trouvée",
  "sections_not_found_desc": "",
  "select_a_template": "Sélectionnez un modèle",
  "select_file": "Choisir le dossier",
  "select_file_desc": "Déposez le fichier ici ou cliquez pour parcourir votre appareil",
  "select_files": "Sélectionnez les fichiers",
  "select_the_from_date": "Sélectionnez la date de début",
  "select_the_to_date": "Sélectionnez le À ce jour",
  "settings": "Réglages",
  "share": "Partager",
  "share_via": "Partage via",
  "show_bot": "Afficher le chatbot",
  "show_chatbots_exercise": "Afficher les chatbots",
  "show_listening_exercise": "Montrer un exercice d'écoute",
  "show_menu": "Afficher le menu",
  "show_options": "Afficher les options",
  "show_pronunciation_exercise": "Afficher l'exercice de prononciation",
  "show_roleplay": "Afficher le jeu de rôle",
  "show_roleplays_exercise": "Afficher les jeux de rôle",
  "show_section": "Afficher la section",
  "show_topic": "Afficher le sujet",
  "show_translation_exercise": "Afficher l'exercice de traduction",
  "skip": "Passer",
  "skip_copy_topic": "Passer",
  "speakers_of": "locuteurs de",
  "start": "Début",
  "start_course": "Commencer le cours",
  "stop": "Arrêt",
  "stop_recording": "Arrêt de l'enregistrement",
  "student_instructions": "Instructions aux étudiants",
  "student_instructions_placeholder": "Instructions aux élèves:\nVous pouvez ajouter votre message d'instruction formaté ici \n\ne.g. \"Bienvenue dans le chatbot, vous pouvez commencer en tapant bonjour \"",
  "student_limit": "Limite d'élèves",
  "subject": "Sujet",
  "submit": "Envoyer",
  "submitting": "Envoi en cours",
  "subscription": "Abonnement",
  "subscription_period_end": "Fin de la période d'abonnement",
  "subscription_status": "Statut de l'abonnement",
  "substitution_desc": "Apportez des modifications au message de l'utilisateur avant de vérifier les déclencheurs.",
  "substitution_name": "Texte original",
  "substitution_name_helper_text": "Le texte d'origine qui peut apparaître dans le message de l'utilisateur",
  "substitution_value": "Texte de substitution",
  "substitution_value_helper_text": "Ne doit pas contenir de symboles spéciaux ou de ponctuation, et doit également être en minuscules",
  "substitutions": "Substitutions",
  "table": "Tableau",
  "thank_you_for_submitting": "Merci de nous avoir soumis votre réponse, nous prendrons contact avec vous dans les plus brefs délais. Revenir à la page d'accueil",
  "the_default_topic_is_random": "Le sujet par défaut est aléatoire",
  "to": "À",
  "toggle_theme": "Changement de fond clair / sombre",
  "toggle_light": "Toggle light theme",
  "toggle_dark": "Toggle dark theme",
  "topic": "Sujet",
  "topic_code": "Code du sujet",
  "topic_desc": "Lorsqu'un utilisateur se trouve dans un sujet, il ne peut faire correspondre que les déclencheurs qui appartiennent à ce sujet.",
  "topic_image": "Image du sujet",
  "topic_information": "Informations sur le sujet",
  "topic_name": "Nom du sujet",
  "topic_not_found": "Sujet introuvable",
  "topic_not_found_desc": "Ce sujet a peut-être été supprimé",
  "topics": "Les sujets",
  "translate": "Traduire",
  "translate_is_disabled": "La traduction est désactivée",
  "translate_this_phrase": "Traduisez cette phrase",
  "translation": "Traduction",
  "translation_exercise_desc": "Testez vos compétences linguistiques en traduisant des phrases",
  "translations": "Traductions",
  "trigger_value": "Déclencher le texte",
  "trigger_value_helper_text": "Ne doit pas contenir de symboles spéciaux ou de ponctuation, et doit également être en minuscules",
  "triggers": "Déclencheurs",
  "triggers_desc": "Un déclencheur est une ligne de texte utilisée pour faire correspondre le message de l'utilisateur.",
  "type": "Type",
  "unarchive": "Désarchiver",
  "undo_action": "annuler",
  "update": "Mise à jour",
  "update_image": "Mettre à jour l'image",
  "update_link": "Mettre à jour le lien",
  "update_phrase": "Mettre à jour la phrase",
  "update_phrase_desc": "Apportez des modifications à la phrase existante",
  "update_picture": "Mettre à jour l'image",
  "update_question": "Mettre à jour la question",
  "update_question_desc": "Posez une question de compréhension, la question peut avoir plusieurs réponses correctes.",
  "update_recording_error": "Un problème est survenu lors de la mise à jour de l'enregistrement",
  "update_review": "Mise à jour de l'examen",
  "update_review_desc": "Mettre à jour la description de la révision",
  "update_section": "Section de mise à jour",
  "update_section_desc": "C'est à vous de structurer le cours, les exemples de structures sont 'Débutant, Intermédiaire, Avancé' ou 'Semaine 1, Semaine 2, Semaine 3'",
  "update_substitution": "Mettre à jour la substitution",
  "update_topic": "Mettre à jour le sujet",
  "update_trigger": "Déclencheur de mise à jour",
  "update_variable": "Mettre à jour la variable",
  "upgrade": "Passer à l'offre supérieure",
  "upload_phrases": "Importer des phrases",
  "upload_phrases_desc": "Créez et téléchargez un fichier csv comme dans l'exemple ci-dessous.",
  "upload_phrases_example_phrase_1": "bonjour",
  "upload_phrases_example_phrase_2": "au revoir",
  "upload_phrases_example_phrase_3": "je m'appelle",
  "upload_phrases_example_definition_1": "Un mot utilisé pour saluer quelqu'un",
  "upload_phrases_example_definition_2": "Un mot utilisé pour dire au revoir à quelqu'un",
  "upload_phrases_example_definition_3": "Une phrase pour se présenter à quelqu'un",
  "upload_script": "Télécharger Le Script",
  "upload_script_desc": "Téléchargez un script de jeu de rôle avec un fichier csv en utilisant le format indiqué ci-dessous",
  "use_keyboard": "Utiliser le clavier",
  "use_word_bank": "Utiliser Word Bank",
  "user_message": "Message d'utilisateur",
  "user_updated": "Utilisateur mis à jour",
  "variable_desc": "Des informations qui peuvent être utilisées dans votre chatbot.",
  "variable_name": "Nom de variable",
  "variable_value": "Valeur variable",
  "variables": "Variables",
  "vars": "Variables",
  "view_activity": "Voir l'activité",
  "view_instruction_message": "Afficher les instructions",
  "view_outline": "Afficher le plan",
  "view_progress": "Voir la progression",
  "visibility": "Visibilité",
  "visit_learning_site": "Accéder au Learning Site",
  "voice_speed_disabled": "La vitesse de la voix n'est pas disponible pour cette voix",
  "weekly_progress": "Progrès hebdomadaire",
  "what_do_you_hear": "Qu'entendez-vous?",
  "answer_method": "Méthode de réponse",
  "answers": "Réponses",
  "attempt_info": "Informations sur l'essai",
  "bot_outputs": "Sorties de chatbot",
  "creator_instructions": "Instructions à l'enseignant",
  "creator_instructions_placeholder": "Vous pouvez ajouter ici un message d'instructions formaté pour un collaborateur de cours, par ex. Bienvenue dans le chatbot, voici comment personnaliser pour vos élèves ...",
  "date": "Date",
  "fri": "ven",
  "listener": "Auditeur",
  "mon": "lun",
  "new_bots": "Nouveaux chatbots",
  "new_courses": "Nouveaux cours",
  "new_roleplays": "Nouveaux jeux de rôle",
  "no_results_found": "Aucun résultat trouvé",
  "option": "Option",
  "play_again": "Recommencer",
  "role_played": "Rôle joué",
  "sat": "Sam",
  "show_word_bank": "Afficher la banque de mots",
  "skipped": "Ignoré",
  "speak": "Parler",
  "sun": "Soleil",
  "text": "Texte",
  "thu": "jeu",
  "time": "Temps",
  "time_spent": "Temps passé",
  "tue": "Mar",
  "view_report": "Voir le rapport",
  "voice": "Voix",
  "wed": "mer",
  "word_bank": "Banque de mots",
  "teach": "Enseigner",
  "active_now": "Actif maintenant",
  "manage_classroom": "Gérer la classe",
  "must_question_least_correct_answer": "Doit être une question et au moins une réponse correcte.",
  "enter_name_your_voice_clip": "Entrez un nom pour votre clip vocal?",
  "my_unnamed_clip": "Mon clip sans nom",
  "are_you_sure": "Êtes-vous sûr?",
  "is_already_created_variable_overwrite": "est déjà une variable créée, voulez-vous l'écraser?",
  "is_already_created_substitution_overwrite": "est déjà une substitution créée, voulez-vous la remplacer?",
  "is_already_created_alternative_overwrite": "est déjà une alternative créée, voulez-vous la remplacer?",
  "is_already_created_topic_overwrite": "est déjà un sujet créé, voulez-vous le remplacer?",
  "bring_your_bot_picture_name": "Donnez vie à votre chatbot en lui donnant une image et un nom",
  "perfect_click_finish_create_bot": "Parfait, cliquez sur Terminer pour créer votre nouveau chatbot",
  "lets_start_with_some_information_about_your_bot": "Commençons par quelques informations sur votre chatbot",
  "lets_start_some_information_about_classroom": "Commençons par quelques informations sur votre classe",
  "the_language_classroom_teach": "La langue que cette classe enseignera",
  "the_language_students_classroom_speak": "La langue parlée par les élèves de cette classe",
  "limit_access_classroom_visibility_private_including_enrolment_key": "Limitez l'accès à votre classe en définissant la visibilité sur privé et en incluant une clé d'inscription",
  "add_collaborators": "Ajouter des collaborateurs",
  "perfect_click_finish_create_classroom": "Parfait, cliquez sur Terminer pour créer votre nouvelle classe",
  "perfect_click_finish_create_course": "Parfait, cliquez sur Terminer pour créer votre nouveau cours",
  "lets_start_information_about_course": "Commençons par quelques informations sur votre cours",
  "the_language_course_teach": "La langue que ce cours enseignera",
  "the_language_students_course_speak": "La langue parlée par les étudiants de ce cours",
  "limit_access_course_setting_visibility_private_including_enrolment_key": "Limitez l'accès à votre cours en définissant la visibilité sur privé et en incluant une clé d'inscription",
  "selected": "Choisi",
  "perfect_click_finish_create_roleplay": "Parfait, cliquez sur Terminer pour créer votre nouveau jeu de rôle",
  "lets_start_with_information_about_roleplay": "Commençons par quelques informations sur votre jeu de rôle",
  "invite": "Inviter",
  "topic_settings": "Paramètres du sujet",
  "topic_title": "Titre du sujet",
  "unanswered_table": "Sans réponse",
  "create_roleplay": "Créer un jeu de rôle",
  "roleplays_not_found_title": "Jeux de rôle introuvables",
  "play": "Commencer",
  "delete": "Supprimer",
  "delete_picture": "Supprimer l'image",
  "use_wordbank_if_stuck": "Utilisez la banque de mots si vous avez besoin d'aide",
  "play_bot_error": "Oups! Un problème est survenu avec le chatbot, veuillez réessayer",
  "bot_editor_preview_error": "Une erreur est survenue. Veuillez visiter https://nualang.com/guides/create-a-bot pour un guide sur la création d'un chatbot",
  "manage_courses": "Gérer les cours",
  "refresh_courses": "Actualiser les cours",
  "customize_appearance_of_course": "Personnalisez l'apparence du cours",
  "customize_appearance_of_classroom": "Personnalisez l'apparence de la salle de classe",
  "customize_appearance_of_topic": "Customize the appearance of the topic",
  "create_duplicate": "Créer un doublon",
  "section_visibility": "Visibilité de la section",
  "choose_a_language": "Choisissez une langue",
  "play_bot": "Commencer le chatbot",
  "lets_find_a_template": "Trouvons un modèle!",
  "search_by_difficulty": "Recherche par difficulté",
  "search_using_keywords": "Rechercher à l'aide de mots-clés",
  "select_a_nualang_template": "Sélectionnez un modèle Nualang",
  "select_a_nualang_template_desc": "Modèles créés par l'équipe de Nualang pour vous aider à démarrer.",
  "or_select_a_community_template": "Ou sélectionnez un modèle de la communauté",
  "or_select_a_community_template_desc": "Les modèles de la communauté sont créés par des enseignants du monde entier.",
  "dashboard_welcome": "Bienvenue, {{name}}!",
  "dashboard_welcome_desc": "Familiarisez-vous avec le tableau de bord, voici quelques façons de commencer.",
  "enter_course_code": "Entrez un code de cours",
  "enter_course_code_desc": "Si vous avez un code de cours, entrez-le ici.",
  "enter_classroom_code": "Entrez un code de classe",
  "enter_classroom_code_desc": "Si vous avez un code de classe, entrez-le ici.",
  "search_nualang": "Explorez Nualang",
  "search_nualang_desc": "Il existe une communauté grandissante d’enseignants partageant les mêmes idées qui développent des conversations avec nos Nualas. Il y a donc toujours quelque chose de nouveau à apprendre.",
  "create_nualang": "Crée le vôtre",
  "create_nualang_desc": "Créez des conversations et des leçons de langue.",
  "roleplay_editor_welcome": "Premiers pas avec l'éditeur de jeu de rôle",
  "roleplay_editor_options": "Sélectionner une option",
  "roleplay_editor_options_desc": "Choisissez un Nuala pour ajouter une nouvelle ligne ou ajoutez une question de compréhension.",
  "roleplay_editor_share": "Partager le jeu de rôle",
  "roleplay_editor_play": "Commencez le jeu de rôle",
  "bot_editor_welcome": "Premiers pas avec l'éditeur de chatbot",
  "bot_editor_sidebar": "Barre latérale de l'éditeur",
  "bot_editor_sidebar_desc": "La barre latérale est l'endroit où vous pourrez apporter des modifications à votre chatbot.",
  "bot_editor_flow_chart": "Flux de chatbot",
  "bot_editor_flow_chart_desc": "Le flux du chatbot montre un aperçu de votre chatbot et donne un aperçu de ce à quoi ressemblera chaque message.",
  "bot_editor_share": "Partager le chatbot",
  "bot_editor_play": "Commencer avec le chatbot",
  "play_roleplay": "Commencer le jeu de rôle",
  "delete_script_item": "Supprimer l'élément du script",
  "delete_script_item_confirmation": "Voulez-vous vraiment supprimer cet élément du script?",
  "add_message": "Ajouter un message",
  "resources": "Ressources",
  "contact": "Contact",
  "sign_in": "S'identifier",
  "sign_up": "S'inscrire",
  "faqs": "Foire aux questions",
  "guides": "Tutoriels",
  "back_to_app": "Retour à l'application",
  "notes": "Notes",
  "notes_placeholder": "Entrez les notes ici",
  "get_in_touch": "Contactez-nous",
  "get_in_touch_desc": "Avez-vous des questions ou des commentaires? Envoyez-nous un message.",
  "avatar_generator": "Générateur d'avatar",
  "avatar_generator_desc": "Créez votre propre avatar personnel",
  "upload_image": "Télécharger l'image",
  "upload_image_desc": "Faites glisser et déposez l'image depuis votre ordinateur",
  "random": "Random",
  "done": "Terminé",
  "file_size_exceeded": "Image trop grande! Veuillez télécharger une image plus petite que ",
  "image_selection_failed": "Impossible de charger cette image. Veuillez essayer une autre image ou télécharger la vôtre.",
  "remove_course": "Supprimer le cours",
  "courses_joined": "Inscription au cours",
  "classroom_courses_not_found_title": "Pas encore de cours",
  "classroom_courses_not_found_desc": "Cette classe n'a pas encore de cours.",
  "in_progress_activity": "En cours",
  "bot_exercise_welcome": "Premiers pas avec l'exercice Chatbot",
  "bot_exercise_restart": "Redémarrez le chatbot!",
  "bot_exercise_keyboard_input": "Tapez-le!",
  "bot_exercise_keyboard_input_desc": "Utilisez le clavier pour saisir un message. Si vous avez besoin d'aide avec des caractères spéciaux ou si vous souhaitez ajouter un emoji, essayez nos touches utiles.",
  "bot_exercise_voice_input": "Dites-le!",
  "bot_exercise_voice_input_desc": "Cliquez sur le microphone pour utiliser votre voix et pratiquer votre prononciation.",
  "bot_exercise_send_message": "Envoyez-le!",
  "bot_exercise_send_message_desc": "Envoyez un message au chatbot et lancez la conversation.",
  "bot_exercise_audio_only_mic": "Dites-le!",
  "bot_exercise_audio_only_mic_desc": "Appuyez sur le microphone pour commencer. Ensuite, parlez naturellement — Nuala écoutera et répondra automatiquement pour le reste de la conversation.",
  "roleplay_exercise_welcome": "Premiers pas avec l'exercice Roleplay",
  "roleplay_exercise_read_script": "Apprenez vos lignes!",
  "roleplay_exercise_read_script_desc": "Lisez la conversation et écoutez comment les mots sont prononcés.",
  "roleplay_exercise_select_an_actor": "Choisissez votre rôle!",
  "roleplay_exercise_select_an_actor_desc": "Sélectionnez le rôle que vous souhaitez jouer.",
  "roleplay_exercise_start": "Commencez!",
  "roleplay_exercise_start_desc": "Cliquez sur Démarrer et utilisez votre clavier ou votre voix pour jouer le rôle que vous avez choisi.",
  "listening_exercise_welcome": "Premiers pas avec l'exercice d'écoute",
  "listening_exercise_speak": "Écoutez la phrase!",
  "listening_exercise_speak_desc": "Cliquez pour écouter la prononciation de la phrase.",
  "listening_exercise_voice_options": "Entendez une autre voix!",
  "listening_exercise_voice_options_desc": "Écoutez la phrase prononcée par différentes voix.",
  "listening_exercise_keyboard_input": "Tapez la réponse!",
  "listening_exercise_keyboard_input_desc": "Utilisez le clavier pour taper la phrase que vous entendez.",
  "listening_exercise_word_bank": "Besoin d'aide?",
  "listening_exercise_word_bank_desc": "Utilisez la banque de mots pour sélectionner la bonne réponse.",
  "translation_exercise_welcome": "Premiers pas avec l'exercice de traduction",
  "translation_exercise_speak": "Écoutez la phrase!",
  "translation_exercise_speak_desc": "Cliquez pour écouter comment la phrase est prononcée.",
  "translation_exercise_read": "Lisez la phrase!",
  "translation_exercise_read_desc": "Lisez la phrase à traduire.",
  "translation_exercise_keyboard_input": "Tapez la réponse!",
  "translation_exercise_keyboard_input_desc": "Utilisez le clavier pour saisir la traduction.",
  "translation_exercise_word_bank": "Besoin d'aide?",
  "translation_exercise_word_bank_desc": "Utilisez la banque de mots pour sélectionner la bonne réponse.",
  "pronunciation_exercise_welcome": "Premiers pas avec l'exercice de prononciation",
  "pronunciation_exercise_speak": "Écoutez la phrase!",
  "pronunciation_exercise_speak_desc": "Cliquez pour écouter comment la phrase est prononcée.",
  "pronunciation_exercise_read": "Lisez la phrase!",
  "pronunciation_exercise_read_desc": "Lisez la phrase à prononcer.",
  "pronunciation_exercise_voice_input": "Prononcez la phrase!",
  "pronunciation_exercise_voice_input_desc": "Cliquez sur le microphone pour utiliser votre voix et pratiquer votre prononciation.",
  "exercise_share": "Partagez avec les autres!",
  "exercise_mute": "Coupez le son!",
  "exercise_skip": "Ignorer!",
  "exercise_skip_desc": "Passez à la phrase suivante, vous pourrez réessayer à la fin.",
  "exercise_restart": "Redémarrez!",
  "what_would_you_like_to_do": "Qu'aimeriez-vous faire?",
  "i_want_to_learn": "Je veux apprendre...",
  "i_want_to_teach": "Je veux enseigner...",
  "add_alternative_version": "Ajouter une version alternative",
  "language_translation_helper_text": "Appuyez sur la touche Entrée / Retour pour ajouter une traduction.",
  "change_roles": "Changer de rôle?",
  "write_your_feedback_here": "Écrivez vos commentaires ici",
  "yes": "Oui",
  "you_are_human_check": "Veuillez confirmer que vous êtes humain",
  "you_will_lose_your_progress_on_this_exercise": "Vous perdrez votre progression sur cet exercice.",
  "confirm": "Confirmer",
  "general": "Général",
  "shuffle_phrases": "Mélanger les phrases",
  "shuffle_phrases_desc": "Rendez l'ordre des questions posées dans les exercices aléatoire.",
  "errors": "Erreurs",
  "missing_translation": "Traduction manquante",
  "missing_phrase": "Phrase manquante",
  "invalid_image_domain": "L'URL de l'image doit provenir d'un domaine Nualang approuvé",
  "row": "Ligne",
  "no_valid_type": "Le type doit être «actor» ou «question»",
  "no_actor_text": "Pas de texte pour l'acteur",
  "no_actor_number": "L'acteur doit avoir un numéro à la fin, par ex. actor1, actor2",
  "no_question": "Pas de question",
  "no_answers_provided": "Aucune réponse fournie",
  "no_correct_answer_provided": "Pas de réponse correcte",
  "no_answers": "Pas de réponses",
  "duplicate_topic": "Sujet en Double",
  "normal_mode": "Mode normal",
  "spreadsheet_mode": "Mode tableau",
  "image": "Image",
  "delete_selected_row": "Supprimer la ligne sélectionnée",
  "crop_image": "Recadrer l'image",
  "crop": "Recadrer",
  "zoom": "Zoom",
  "rotate": "Tourner",
  "hide_preview": "Masquer l'aperçu",
  "show_preview": "Afficher l'aperçu",
  "try_again": "Réessayer",
  "confidence_score": "Le pourcentage de confiance indique la probabilité que les mots individuels aient été reconnus correctement.",
  "subscription_plan_teach": "Forfait enseignants",
  "subscription_plan_teacher_pro": "Enseignant PRO",
  "subscription_plan_basic": "Enseignant Basic",
  "subscription_plan": "Forfait d'inscription",
  "subscription_status_trialing": "Essai gratuit",
  "subscription_status_active": "Actif",
  "subscription_status_canceled": "Annulé",
  "subscription_status_undefined": "Gratuit",
  "status": "Statut",
  "upgrade_plan": "Mise à jour du forfait",
  "manage_plan": "Gestion du forfait",
  "cancel_plan": "Annuler le forfait",
  "your_plan": "Votre forfait",
  "plan_cost": "Coût du forfait",
  "next_billing_date": "Fin de facturation pour ce trimestre",
  "free": "Gratuit",
  "payment_method": "Méthodes de paiement",
  "pricing_page_title": "Choisissez votre forfait",
  "pricing_page_subtitle": "Types de forfaits pour les enseignants, écoles et collectivités.",
  "pricing_page_testimonials_title": "Ce qu'en disent les profs",
  "compare_plans": "Comparer les forfaits",
  "features": "Fonctions",
  "upgrade_submit": "Mise à jour",
  "upgrade_subscription_desc": " Pour avoir accès à cette fonction, veuillez mettre à jour votre compte. Cliquer pour accéder à la page de forfaits.",
  "upgrade_plan_explanation": "Pour avoir accès à cette fonction, veuillez mettre à jour votre compte.",
  "upgrade_subscription_student": "Cette fonction n'est accessible qu'aux enseignants.",
  "public_visibility_disabled_wayside": "Les classes sont gérées par Wayside Publishing et doivent rester privées.",
  "public_visibility_disabled_loading": "Nous vérifions encore votre abonnement. Veuillez actualiser la page si rien ne change.",
  "public_visibility_disabled_trial": "Les classes publiques ne sont pas disponibles pendant l'essai gratuit. Passez à un abonnement payant pour rendre cette classe publique.",
  "creator_not_subscribed": "Vous ne pouvez pas avoir accès à ce contenue car son créateur n'est pas actuellement inscrit.",
  "first_name": "Prénom",
  "last_name": "Nom",
  "role": "Role",
  "school_name": "Nom de l'école",
  "school_district": "Collectivités",
  "city": "Ville",
  "state": "Département",
  "send_message": "Envoyer un Message",
  "sign_me_up": "Incrivez-moi !",
  "free_trial": "Essai Gratuit",
  "interactive_demo": "Démonstration interactive",
  "news_and_updates": "Nouvelles et Mise à jour",
  "teacher": "Enseignant",
  "principal": "Principal",
  "tutor": "Tuteur",
  "parent": "Parent",
  "student": "Elève",
  "other": "Autre",
  "none": "Aucan",
  "group_subscription_plans": "Forfait de groupe",
  "group_plan": "Tarif de groupe",
  "leave_group": "Quitter le groupe",
  "joined_subscription": "Forfait groupé",
  "joined_subscription_desc": "Bienvenue au {{groupName}}forfait groupé, vous utilisez Enseignants PRO!",
  "unable_to_join_subscription": "Inscription râtée",
  "unable_to_join_subscription_desc": "Un problème d'inscription est survenu.Veuillez réessayer plus tard",
  "unable_to_join_subscription_invalid_email_desc": "Vous ne pouvez pas intégrer ce groupe sans posséder un de ces domaines d'email: {{allowedDomains}}",
  "unable_to_join_subscription_limit_reached_desc": "'{{groupName}}' a atteint sa capacité. Veuillez contacter l'administrateur de groupe pour accroître sa capacité.",
  "moderated_image_dialog": "Nualang detected an image that was inappropriate, unwanted, or offensive and blocked it to provide a safer user experience. Please try a different image.",
  "moderate_title": "Image bloquée",
  "recommended_courses": "Cours recommandés",
  "subscription_status_trialing_expired": "Fin de la période d'essai gratuit",
  "no_public_content_created": "Pas de contenu public créé",
  "add_tag": "Appuyer sur entrée/retour pour ajouter un mot-clé",
  "add_collaborator_tag": "Appuyer sur entrée/retour pour ajouter un collaborateur",
  "add_to_classroom": "Ajouter à la classe",
  "add_to_classroom_desc": "Ajouter '{{courseName}}' à {{classroomNames}}.",
  "change_voice_speed": "Changer la vitesse de la voix!",
  "extra_fast": "Vitesse rapide",
  "fast": "Vitesse très rapide",
  "medium": "Vitesse normale",
  "slow": "Ralentissez légèrement",
  "extra_slow": "Un mot à la fois",
  "card_ALL": "Tout",
  "join_classroom_to_access": "Intégrer la classe pour accéder au contenu",
  "join_course_to_access": "Intégrer le cours pour accéder au contenu",
  "confidence": "Confiance",
  "teach_lang": "Je veux enseigner",
  "write_feedback": "Ecrivez votre commentaire",
  "allowed_domains": "Accepter le domaine de l'école (optionnel)",
  "add_allowed_domains_desc": "Restreindre l'accés lié au domaine de l'école par exeample 'schooldomain.com'",
  "send_feedback": "Envoyer un commentaire",
  "add_feedback": "Ajouter un commentaire",
  "feedback_content": "Contenu de commentaire",
  "report_problem": "Signalement d'un problème",
  "report_problem_input_label": "Description du problème",
  "update_feedback": "Mise à jour de commentaire",
  "student_completes_exercise": "Quand un élève termine un exercice",
  "delete_feedback_confirmation": "Etes-vous sûr de vouloir effacer ce commentaire",
  "delete_feedback": "Effacez le commentaire",
  "updates_to_our_terms_of_service": "Mise à jour de nos conditions d'utilisation",
  "email_me_when": "Enoyez-moi un e-mail si:",
  "new_classroom": "Nouvelle classe",
  "student_progress": "Progrès de l'élève",
  "view_course": "Voir le cours",
  "view_section": "Voir la section",
  "classroom_members_not_found_title": "Pas encore de membres",
  "classroom_members_not_found_desc": "Cette classe n'a pas encore de membres.",
  "open_topic": "Sujet ouvert",
  "click_to_speak": "cliquer pour parler",
  "click_to_stop": "cliquer pour arrêter",
  "listening_indicator": "Ecoutez ...",
  "save_recording_to_report": "Sauvegarder l'enregistrement pour le rapport",
  "no_voice_recording_saved": "l'enregistrement de votre voix n'a pas été sauvegardé",
  "classrooms_not_created": "Aucune classe de créée",
  "select_a_classroom": "Sélectionnez une classe",
  "voice_attempt": "Essai de voix",
  "upload_variables": "Charger les variables",
  "next_game": "Jeu suivant",
  "roleplay_games": "Jeux de jeux de rôle",
  "roleplay_games_description": "Cliquer sur une des cartes ci-dessous pour jour à un jeu particulier.",
  "choose_game_mode": "Choisissez un mode de jeu",
  "story": "Histoire",
  "story_description": "Ecoutez la conversation entre les personnages et répondez aux questions pour vérifier votre compréhension.",
  "fill_in_blanks": "Remplissez les blancs",
  "fill_in_blanks_description": "Pouvez-vous identifier correctement ce qui manque?",
  "fill_in_the_blanks": "Remplissez les blancs",
  "fill_in_the_blanks_description": "Pouvez-vous identifier correctement ce qui manque?",
  "act_it_out": "Simulez",
  "act_it_out_description": "Pouvez-vous sélectionner la bonne réponse?",
  "act_it_out_listening": "Simulez - Ecouter",
  "act_it_out_listening_description": " Utilisez votre compréhension orale pour sélectionner la bonne réponse",
  "act_it_out_speaking": "Simulez - Parler",
  "act_it_out_speaking_description": "Pratiquer votre prononciation en disant votre ligne.",
  "act_it_out_listening_speaking": "Simulez - Ecouter et Parler",
  "act_it_out_listening_speaking_description": "Pratiquer votre prononciation en disant votre ligne.",
  "select_role": "Sélectionnez votre rôle",
  "select_role_description": "Sélectionner le rôle que vous voulez simuler.",
  "mute": "Couper le son",
  "unmute": "Rétablir le son",
  "replay": "Recommencer",
  "restart": "Recommencer",
  "group_courses": "Cours groupés",
  "select": "Sélectionner",
  "classroom_creator_welcome": "Commencer avec votre classe",
  "classroom_creator_add_courses": "Ajouter des cours",
  "classroom_creator_add_students_email": "Invitez des élèves - Envoyer une invitation par email",
  "classroom_creator_track_progress": "Suivi de l'activité des élèves",
  "classroom_creator_track_progress_desc": "Une fois que les élèves ont rejoint la classe, cliquer pour vérifier leur progrès sur les cours ajoutés.",
  "forLang_and_learnLang_the_same": " La langue d'apprentissage et du locuteur est la même. L'exercice de traduction est de ce fait désactivé",
  "english": "Anglais",
  "french": "Français",
  "german": "Allemand",
  "irish": "Gaélique",
  "italian": "Italien",
  "portuguese": "Portugais",
  "spanish": "Espagnol",
  "close": "Fermer",
  "last": "Dernier",
  "classroom": "classe",
  "stop_speaking": "Stop Speaking",
  "update_avatar": "Actualisation de l'Avatar",
  "update_avatar_desc": "Actualisation de votre propre avatar",
  "invite_students": "Invitez les élèves",
  "share_student_link_desc": "Partagez les instructions ci-dessous pour inviter les élèves à s'inscrire.",
  "invite_link_desc": "Veuillez vous inscrire et créer un compte Nualang en cliquant sur ce lien d'invitation:",
  "join_instructions_1": "Vous irez ",
  "join_instructions_2": "J'ai créé pour vous, où vous cliquerez 'S'incrire'",
  "enrollment_key_text": "et sélectionnez la clé d'inscription: ",
  "copy_student_instructions": "Copiez les instructions pour les élèves",
  "or_invite_via": "Ou invitez par le biais de",
  "invite_email_subject": "Invitation à s'inscrire à Nualang",
  "dear_students": "Chers élèves",
  "dashboard": "Tableau de bord",
  "preview_roleplay": "Aperçu du jeu de rôle",
  "roleplay_preview": "Aperçu",
  "roleplay_preview_decription": "Aperçu de tout le texte du jeu de rôle",
  "sort": "Triez",
  "sort_by": "Trier par",
  "newest": "Plus récent",
  "alphabetical": "Alphabétique",
  "recently_changed": "Récemment modifié",
  "recently_viewed": "Récemment consulté",
  "oldest": "Plus ancien",
  "default": "Par défaut",
  "clear_filters": "Effacer les filtres",
  "member": "Membre",
  "agree_to_terms_and_conditions_1": "J'accepte les ",
  "nualang_terms": "conditions d'utilisation de Nualang",
  "agree_to_terms_and_conditions_2": ", ainsi que sa politique de ",
  "privacy_policy": "confidentialité et de protection des données",
  "first_classroom_description": "This is a classroom to help students speak {{learnLang}} with confidence.",
  "upload": "Upload",
  "download": "Download",
  "classroom_creator_add_students_email_desc": "Click to explore different ways to invite students to your classroom.",
  "bot_sign_in_message": "You must be signed in to play this chatbot",
  "course_sign_in_to_access": "Sign in to access this course",
  "have_an_account": "Have an account?",
  "provide_a_little_more_information": "Provide a little more information",
  "instructions": "Instructions",
  "close_preview": "Close Preview",
  "check_recognition": "Check speech recognition",
  "checking_recognition": "Checking speech recognition ...",
  "phrase_recognised": "Phrase recognised",
  "phrase_not_recognised": "Phrase not recognised",
  "speech_recognition_info": " Checking the speech recognition allows you to determine whether or not your students will have difficulty pronouncing this phrase in our exercises.",
  "speech_recognition_error_info": "We recognised your phrase as {{recognisedPhrase}}. We recommend that you reword the phrase and/or add an alternative version.",
  "my_library": "My Library",
  "add_own_exercise_message": "Create new {{exerciseName}} using templates created by you",
  "no_exercises_in_library": "There are no {{exerciseName}} created by you.",
  "classroom_invite_feature_disabled_message": "This feature is disabled because your students will be able to join this classroom automatically.",
  "skip_navigation": "Skip Navigation",
  "generate_roleplay": "Generate Roleplay",
  "choose_topic_for_roleplay": "Choose a topic for the roleplay",
  "roleplay_generated": "Roleplay Generated",
  "select_roleplay": "Select Roleplay",
  "chatgpt_roleplay_description": "This is a roleplay about {{topic}}",
  "check_answer": "Check Answer",
  "card": "Carte",
  "banner": "Banniére",
  "load_more": "Load More",
  "bot_input_placeholder": "Use the keyboard to type a message",
  "bot_input_mobile_placeholder": "Type a message...",
  "audio_only_mode": "Écouter et Parler",
  "audio_only_tooltip": "Passer en mode audio uniquement",
  "switch_to_text": "Passer au texte",
  "switch_to_text_tooltip": "Revenir au mode texte",
  "audio_only_title": "Parle avec {{botName}}",
  "audio_only_subtitle": "Une conversation entièrement orale — sans aucun texte. Casque recommandé.",
  "audio_only_mode_unavailable_fallback_chat": "Cet exercice nécessite le mode Écouter et parler, mais il n'est pas disponible sur cet appareil ; il se poursuit en mode Chat.",
  "microphone_ready": "Microphone prêt",
  "bot_is_speaking": "En train de parler...",
  "thinking_indicator": "Réflexion...",
  "start_conversation": "Démarrer la conversation",
  "stop_button_label": "Arrêter",
  "stop_bot_message": "Arrêter la voix du chatbot",
  "choose_mode_text_option": "Chat",
  "choose_mode_text_option_desc": "Tape ou dis tes réponses, puis lis ou écoute les réponses du bot.",
  "bot_mode_in_progress_icon": "{{mode_name}} conversation currently in progress",
  "bot_mode_completed_icon": "{{mode_name}} completed {{counter}} time",
  "bot_modes_completed_icon": "{{mode_name}} completed {{counter}} times",
  "replay_button_label": "Rejouer",
  "replay_bot_message": "Répéter le message du chatbot",
  "you": "Toi",
  "ready_when_you_are": "Prêt quand tu veux",
  "bot_speaking_banner": "{{botName}} est en train de parler",
  "listening_to_you": "À l'écoute",
  "bot_thinking_banner": "{{botName}} réfléchit",
  "one_moment": "Un instant",
  "listen_first": "Écoute d'abord",
  "tap_when_done": "Appuie quand tu as fini",
  "conversation_complete": "Conversation terminée",
  "exchanges_label": "Échanges",
  "time_spoken_label": "Temps de parole",
  "review_your_turns": "Revoir tes échanges",
  "submit_to_teacher": "Envoyer à l'enseignant",
  "great_job": "Bravo !",
  "or": "or",
  "choose_difficulty_of_roleplay": "Choose a difficulty for the roleplay",
  "child": "Child",
  "game_visibility": "Game Visiblity",
  "duplicate_course": "Duplicate Course",
  "amount_must_not_exceed_10": "Amount must not exceed 10",
  "amount_must_be_greater_than_0": "Amount must be greater than 0",
  "voice_pitch": "Voice Pitch",
  "voice_pitch_example": "Bonjour, je m'appelle {{name}}",
  "voice_pitch_disabled": "Adjusting the pitch is not possible for this voice.",
  "voice_pitch_x_low": "Very Low",
  "voice_pitch_low": "Low",
  "voice_pitch_medium": "Medium",
  "voice_pitch_high": "High",
  "voice_pitch_x_high": "Very High",
  "contact_us": "Contact Us",
  "contact_us_message": "Thank you for using Nualang. Please send your message below and we will get back to you at the earliest.",
  "expected_phrases": "Expected Phrases",
  "expected_phrases_info": "Phrases you expect your students to use during the exercise that you'd like to be recognised correctly when the student speaks. For example, if the exercise was about the weather you might want to recognise the word 'weather' more often than 'whether'",
  "add_expected_phrases": "Add Expected Phrases",
  "phrase_length_exceeded_error": "Phrase should not exceed 100 characters",
  "whats_new": "What's New",
  "wayside_subscription_message": "Your subscription is managed by Wayside Publishing",
  "select_the_correct_answer": "Select the correct answer",
  "pronunciation_score": "Pronunciation score",
  "pronunciation_score_explanation": "The pronunciation score is based on the number of words recognised correctly ({{transcriptCompletenessPercentage}}%) and how clearly they were recognised.",
  "add_course": "Add Course",
  "generate_roleplay_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "experimental_feature_desc": "New AI Feature - We would love to hear your feedback",
  "generating_roleplay": "Generating Roleplay",
  "updated": "Updated",
  "exercise_completed": "Exercise Completed",
  "exercise_not_completed": "Exercise Not Completed",
  "view_topic": "View Topic",
  "view_roleplay": "View Roleplay",
  "view_bot": "View Chatbot",
  "student_reports_problem": "A student reports a problem during an exercise",
  "problem_reported": "Problem reported",
  "remove_course_confirmation": "Are you sure you want to remove this course?",
  "classroom_member_limit_reached": "Classroom has reached its student limit",
  "upload_pdf": "Upload PDF",
  "remove_pdf": "Remove PDF",
  "classroom_updated": "Classroom Updated",
  "deleted": "Deleted",
  "created": "Created",
  "moderation_warning": "The following categories were detected in your uploaded image(s): ",
  "warning": "Warning",
  "use_anyways": "Use Anyways",
  "view_pdf": "View Story",
  "schedule_discussion": "Schedule discussion",
  "video_chat": "Video Chat",
  "video_chat_member": "Video Chat Member",
  "create_meeting": "Create meeting",
  "group_assignment": "Group assignment",
  "join_group": "Join Group",
  "groups": "Groups",
  "group": "Group",
  "welcome": "Welcome",
  "classroom_creator_welcome_free_trial": "Welcome to your 30 day free trial of Nualang! To get you started, we have setup your first classroom.",
  "delete_pdf": "Delete PDF",
  "delete_pdf_confirmation": "Are you sure you want to delete this PDF?",
  "course_updated": "Course updated",
  "overwrite_phrases": "Overwrite Phrases",
  "roleplay_game_in_progress_icon": "Roleplay game currently in progress",
  "roleplay_game_completed_icon": "Roleplay game has been completed {{counter}} time",
  "roleplay_games_completed_icon": "Roleplay game has been completed {{counter}} times",
  "page": "Page",
  "unknown": "Inconnu",
  "add_a_discussion_topic": "Ajouter un Sujet de Discussion",
  "add_a_url_for_students_to_discuss": "Ajouter une URL pour que les Étudiants Discutent",
  "images_that_students_can_use_as_a_background_during_the_call": "Images que les Étudiants Peuvent Utiliser comme Arrière-Plan Pendant l'Appel",
  "discussion_images": "Images de Discussion",
  "images_for_students_to_discuss_during_the_call": "Images pour que les Étudiants Discutent Pendant l'Appel",
  "recording_time": "Temps d'Enregistrement",
  "due_date": "Date Limite",
  "interculturarity": "Interculturalité",
  "comprehensibility": "Compréhensibilité",
  "function_and_text_type": "Fonction et Type de Texte",
  "vocabulary_in_context": "Vocabulaire en Contexte",
  "Drag_and_drop_image_from_your_computer": "Glisser et Déposer une Image depuis Votre Ordinateur",
  "record_time_limit": "Limite de Temps d'Enregistrement",
  "schedule_discussion_options": "Options de Programmation des Discussions",
  "chat_options": "Options de Discussion",
  "recording_info": "Submission Info",
  "discussion_id": "ID de Discussion",
  "discussion_prompt": "Sujet de Discussion",
  "attendees": "Participants",
  "created_discussions": "Discussions Créées",
  "create_groups": "Créer des Groupes",
  "select_all": "Sélectionner Tout",
  "remove_group": "Supprimer Un Groupe",
  "grouped_discussions": "Discussions Groupées",
  "no_recordings_found": "Aucun Enregistrement Trouvé",
  "recordings": "Enregistrements",
  "scheduled_meetings": "Réunions Planifiées",
  "no_meetings_scheduled": "Aucune Réunion Planifiée",
  "discussion_info": "Informations sur la Discussion",
  "invites": "Invitations",
  "invited_members": "Membres Invités",
  "minute": "Minute",
  "feedback": "Feedback",
  "view": "Vue",
  "no_data_found": "Aucune Donnée Trouvée",
  "no_past_discussions_found": "Aucune Discussion Passée Trouvée",
  "no_submissions_found": "Aucune Soumission Trouvée",
  "background_images": "Images de Fond",
  "no_scheduled_discussions_found": "Aucune Discussion Planifiée Trouvée",
  "view_more": "Voir Plus",
  "past": "Passé",
  "submissions": "Soumissions",
  "add_a_discussion_prompt": "Ajouter une Incitation à la Discussion",
  "join_live_game": "Join Live Game",
  "live_game_medals": "Médailles de jeu en direct",
  "live_game_medals_description": "Débloquez des médailles en terminant 1er, 2e ou 3e lors d'un jeu en direct",
  "classroom_has_no_live_game": "Classroom currently has no live game",
  "speech_recognition_error_info_no_phrase": "We did not recognise your phrase. We recommend that you reword the phrase and/or add an alternative version.",
  "no_conversation_available": "Aucune conversation disponible",
  "enrolment_key_min_chars": "Enrolment key must be at least 5 characters long",
  "zoom_in": "Zoom In",
  "zoom_out": "Zoom Out",
  "game_created": "Game created",
  "play_live": "Play Live",
  "play_live_desc": "Select the exercise you'd like to play live in the classroom.",
  "live_dialog_description": "Select the exercise you'd like to play live in the classroom.",
  "no_special_characters": "Cannot contain special characters",
  "required": "Required",
  "nuala_performance_rating": "Évaluation des performances de Nuala",
  "using_nuala_performance": "Si vous utilisez l'évaluation des performances de Nuala, vous perdrez toute évaluation créée manuellement.",
  "are_you_sure_nuala_performance": "Êtes-vous sûr de vouloir utiliser l'évaluation des performances de Nuala ?",
  "course_deletion_note": "*Note deleting this course will also delete the {{sectionCount}} section(s) in this course and its contents",
  "classroom_deletion_note": "*Note deleting this classroom will also delete the {{courseCount}} course(s) in this classroom and its contents",
  "topic_deletion_note": "*Note deleting this topic will also delete the {{phraseCount}} phrase(s), {{botCount}} chatbot(s) and {{roleplayCount}} roleplay(s) in this topic and its contents",
  "section_deletion_note": "*Note deleting this section will also delete the {{topicCount}} topic(s) in this section and its contents",
  "confirmDeletionText": "To confirm deletion, type 'delete' into the field below",
  "subscription_status_cancelled": "Cancelled",
  "subscription_status_active expired": "Expired",
  "subscription_status_active_expired": "Expired",
  "leaderboard": "Leaderboard",
  "waiting_message": "Get ready, the game will start soon",
  "play_game": "Play Game",
  "close_game": "Close Game",
  "cancel_game": "Cancel Game",
  "end_game": "End Game",
  "games": "Games",
  "course_no_sections": "This course has no sections",
  "topic_no_phrases": "This topic has no phrases",
  "next_question": "Next question",
  "your_answer": "Your answer",
  "change_answer": "Change answer",
  "final_results": "Results",
  "game_ended": "Game ended",
  "joined_game": "Joined game",
  "equipment_problem_label": "Equipment problem",
  "equipment_problem_example": "e.g. My speaker or microphone is not working",
  "technical_problem_label": "Technical problem",
  "technical_problem_example": "e.g. The app is not working correctly",
  "content_problem_label": "Content problem",
  "content_problem_example": "e.g. I noticed a mistake in the exercise content",
  "end_question_early": "End Question Early",
  "discussion_topic": "Discussion Topic",
  "discussion_link": "Discussion Link",
  "scheduled": "Scheduled",
  "go_back_to_classroom": "Go back to Classroom",
  "discussion_created": "Discussion Créée",
  "discussion_updated": "Discussion mise à jour",
  "give_feedback": "Donner un Retour",
  "nualang_live_welcome": "Welcome to Nualang Live!",
  "nualang_live_invite": "Invite Students",
  "nualang_live_invite_desc": "Click here to see how students join the game.",
  "nualang_live_game_members": "Game Members",
  "nualang_live_game_members_desc": "Click here to see who hasn't joined the game yet.",
  "nualang_live_start_game": "Start the game!",
  "nualang_live_settings": "Game Settings",
  "nualang_live_settings_desc": "Click here to see game options",
  "timer_length": "Timer Length",
  "keyboard_and_word_bank": "Keyboard and Word Bank",
  "keyboard_only": "Keyboard Only",
  "word_bank_only": "Word Bank Only",
  "answer_options": "Answer Options",
  "game_settings": "Game Settings",
  "create_feedback": "Create Feedback",
  "first_place": "First Place",
  "second_place": "Second Place",
  "third_place": "Third Place",
  "final_score": "Final Score",
  "no_discussions_found": "Aucune discussion trouvée",
  "no_discussions_found_desc": "Toutes les discussions et soumissions peuvent être trouvées ici",
  "quality_of_interaction": "Qualité de l'Interaction",
  "number_of_questions": "Number of Questions",
  "estimated_game_time": "Estimated Game Time",
  "minutes": "Minutes",
  "discuss": "Discuter",
  "open_live_game": "Open Live Game",
  "correct_answers": "Correct Answers",
  "game_has_ended": "This game has ended, please wait for a new Live Game.",
  "game_has_canceled": "This game has been canceled, please wait for a new Live Game.",
  "allow_wordBank": "Allow students to use the word bank in exercises",
  "creator_default": "Creator's default",
  "course_default": "Course default",
  "course_settings_description": "Adjust the learning experience for students of this classroom",
  "change_settings": "Change Settings",
  "choose_topic_from_pdf_for_roleplay": "Choose a topic for the roleplay based on context from the course pdf",
  "use_context_from_course_pdf": "Use context from course pdf",
  "use_context_from_course_pdf_info": "Turn this on to be able to generate a roleplay based on the contents of the course pdf if the  prompt is relevent to the contents in the pdf",
  "feedback_all_info": "Fournit des commentaires à tous les membres du groupe de discussion. Vous ne pouvez pas fournir à la fois des commentaires de groupe et individuels à un étudiant.",
  "rubric_info_desc": "View the Analytic Growth Rubric, the criteria being used in our AI feedback.",
  "rubric_info": "Informations sur la grille d'évaluation",
  "listen_to_story": "Listen to the Story",
  "roleplay_no_interactions": "This roleplay has no interactions",
  "number_of_interactions": "Number of Interactions",
  "archive_title_submissions": "Archive Submissions",
  "archive_description_submissions": "Are you sure you want to archive the submissions?",
  "archive_title": "Archive Discussion",
  "archive_description": "Are you sure you want to archive this discussion? Students invites to this discussion will also be removed.",
  "discussion_templates": "Modèles de Discussion",
  "discussion_templates_desc": "Utilisez l'un de nos modèles de discussion prédéfinis, ici pour vous aider à créer du contenu pour vos étudiants",
  "find_courses": "Find Courses",
  "create_your_own": "Create Your Own ",
  "community_courses_description": "Find a course from the library for your students",
  "create_your_own_description": "Build a brand new course for your students",
  "empty_live_dialog_description": "Add a course if you'd like to play live in the classroom.",
  "no_classroom_to_join": "Your teacher has not setup their classroom on Nualang yet. Please ask them to do so, then try again.",
  "resume": "Resume",
  "pause": "Pause",
  "discuss_welcome": "Guide de Discussion",
  "discuss_scheduled_discussions": "Discussions Programmées",
  "discuss_scheduled_discussions_desc": "C'est ici que vous trouverez les discussions programmées par l'enseignant. Vous pourrez rejoindre ces discussions et parler d'un sujet avec d'autres étudiants de votre groupe.",
  "discuss_refresh_discussions": "Actualiser les Discussions",
  "discuss_refresh_discussions_desc": "Ce bouton vous permettra d'actualiser pour obtenir les dernières discussions programmées.",
  "discuss_recorded_discussions": "Enregistrer les Discussions",
  "discuss_recorded_discussions_desc": "Ici vous pouvez trouver les discussions que vous avez enregistrées et soumises à l'enseignant pour examen. Une fois que les commentaires sont donnés, vous pourrez les consulter.",
  "discuss_grouped_discussions": "Discussions groupées",
  "discuss_grouped_discussions_desc": "Vous pouvez trouver ici toutes les discussions que vous avez créées pour vos étudiants en fonction du nom du sujet. Cliquez sur une discussion groupée pour voir quelles groupes d'étudiants ont été créés.",
  "discuss_submissions": "Soumissions de discussion",
  "discuss_submissions_desc": "Vous pouvez trouver ici les soumissions de discussion enregistrées créées par des groupes d'étudiants. Vous pouvez visionner leur enregistrement, ainsi que la transcription des discussions et donner des commentaires individuels ou groupés.",
  "refresh_discuss": "Actualiser la Discussion",
  "classroom_creator_add_courses_desc": "Choose how you want to add courses to the classroom.",
  "nuala_ai": "Nuala IA",
  "performance_ratings": "Évaluations de performance",
  "attended": "Présent",
  "did_not_attend": "N'a pas assisté",
  "discussion_attendance": "Assiduité aux discussions",
  "submitted_recordings": "Enregistrements soumis",
  "invalid_date": "Invalid Date",
  "go_to_profile_settings": "Go to profile settings",
  "not_applicable": "Omit",
  "comprehension": "Comprehension",
  "feedback_text": "Feedback Text",
  "submit_feedback": "Submit Feedback",
  "select_students_to_group": "Select All Students",
  "created_groups": "Created Groups",
  "feedback_info": "Feedback Info",
  "sample_discussion_ideas": "Sample Discussion Ideas",
  "image_library": "Image Library",
  "interculturality": "Interculturality",
  "add_alternative_version_explanation": "Ajouter une version alternative de la phrase à marquer comme correcte, par exemple 'You are welcome' pourrait être une alternative à 'You're welcome'",
  "upload_video": "Télécharger la Vidéo",
  "select_video_desc": "Faites glisser et déposez une vidéo depuis votre ordinateur",
  "add_video": "Ajouter une Vidéo",
  "video_info": "Vidéo de Cours",
  "play_video": "Lire la Vidéo",
  "delete_video": "Supprimer la Vidéo",
  "delete_video_confirmation": "Êtes-vous sûr de vouloir supprimer cette vidéo ?",
  "view_video": "Voir la Vidéo",
  "video_options": "Options Vidéo",
  "congratulations": "Congratulations!",
  "medal_has_been_added_to_your_profile": "A medal has been added to your profile",
  "pdf_options": "PDF Options",
  "disable_keyboard": "Disable Keyboard",
  "enable_keyboard": "Enable Keyboard",
  "view_story": "View Story",
  "view_question": "View Question",
  "save_library": "Save to Library",
  "minimum_two_phrases": "This exercise requires a minimum of two phrases in the topic.",
  "roleplay_not_valid": "This exercise requires a minimum of one interaction and one question.",
  "move_topic": "Move Topic",
  "move_section": "Move Section",
  "move_roleplay": "Move Roleplay",
  "duplicate_roleplay": "Duplicate Roleplay",
  "leave_game": "Leave Game",
  "leave_game_confirmation": "Are you sure you want to leave this game?",
  "leave": "Leave",
  "explore": "Explore",
  "listen": "Listen",
  "download_template": "Download Template",
  "member_activity": "Student Activity",
  "move_phrase": "Move Phrase",
  "multiple_choice": "Multiple Choice",
  "record": "Record",
  "nualang_live_help": "How to play",
  "nualang_live_help_desc": "Click here to see how to play the game",
  "roleplay-story": "Story",
  "teach_classrooms_desc": "Manage and interact with your students in a dynamic learning environment",
  "teach_classrooms_title": "Engage Your Classroom",
  "teach_courses_desc": "Design and structure your curriculum to provide a complete learning experience",
  "teach_courses_title": "Build comprehensive courses",
  "teach_roleplays_title": "A new kind of Roleplay",
  "teach_roleplays_desc": "Teaching with roleplays allows your students to participate in scripted conversations, providing a dynamic and immersive way to practice their language skills",
  "teach_bots_title": "Creativity with chatbots",
  "teach_bots_desc": "Teaching with chatbots can help your students develop confidence and a natural conversational style that flows seamlessly, similar to real-life conversations",
  "learn_bots_title": "Creativity With Chatbots",
  "learn_bots_desc": "Learning with chatbots can help you develop a natural and engaging conversational style that flows seamlessly, just like a real conversation",
  "learn_roleplays_title": "A new kind of Roleplay",
  "learn_roleplays_desc": "Learning with roleplays allows you to participate in scripted conversations, providing a dynamic and immersive way to practice language skills",
  "learn_classrooms_desc": "Join classrooms where you can interact with your peers and teachers in a dynamic learning environment",
  "learn_classrooms_title": "Interactive Learning Spaces",
  "learn_courses_desc": "Enroll in courses designed to give you a complete learning experience with structured lessons and activities",
  "learn_courses_title": "Comprehensive learning paths",
  "video_included": "Video",
  "story_included": "Story",
  "answer_helper_text": "Press enter / return key to add answer.",
  "move_answer": "Move Answer",
  "remove_answer": "Remove Answer",
  "remove_question": "Supprimer la question",
  "supported_file_types": "Supported file types: mp4, mov",
  "exercise_description": "Listen to this phrase",
  "translate_description": "Translate the phrase as quick as you can for the most points!",
  "result_description": "See where you place against everyone else!",
  "listening_description": "Choose an answer as quick as you can for the most points!",
  "roleplay_intro": "Listen to the conversation between the two characters!",
  "topic_no_roleplays": "This topic has no roleplays.",
  "case_sensitive": "This was marked for case sensitivity",
  "required_field": "Fields marked with * are required",
  "close_drawer": "Close Drawer",
  "generate_question": "Generate Question",
  "generating_question": "Generating Question",
  "experimental_feature_desc_answer": "The 'Generate Question' button is a New AI Feature - We would love to hear your feedback",
  "question_type": "Question Type",
  "multiple_choice_factual": "Multiple Choice - Factual",
  "multiple_choice_inference": "Multiple Choice - Inference",
  "vocabulary": "Vocabulary",
  "true_false": "True/False",
  "insert_emoji": "Insert Emoji",
  "moderation_reason": "Image was blocked for containing: {{moderationReason}}",
  "move_bot": "Move Chatbot",
  "duplicate_bot": "Duplicate Chatbot",
  "experimental_feature_desc_phrases": "The 'Generate Phrases' button is a New AI Feature - We would love to hear your feedback",
  "choose_topic_for_phrases": "What would you like the phrases to be about?",
  "how_many_phrases": "Number of Phrases: {{phraseAmount}}",
  "generate_phrases": "Generate Phrases",
  "generating_phrases": "Generating Phrases",
  "discuss_description": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "enable_discuss": "Enable Discuss in Settings",
  "duplicate_answer_desc": "A question cannot have duplicate answers",
  "incomplete_translation": "There is still more to this sentence!",
  "question_language": "Choose a language for the questions and answers",
  "generate_questions": "Generate Questions",
  "enable_gen_questions": "Enable this to generate comprehension questions related to the roleplay.",
  "use_topic_phrases": "Use Topic Phrases",
  "enable_phrase_context": "Enable this to use the phrases from your Topic as context in generating the roleplay.",
  "add_phrase_context": "Please add phrases to your topic to enable this feature.",
  "enter_phrase_with_alternatives": "Enter a phrase with alternatives",
  "sentences": "Sentences",
  "words": "Words",
  "phrase_type": "Phrase Type",
  "archive_classroom": "Archive Classroom",
  "archive_classroom_confirmation": "Are you sure you want to archive this classroom?",
  "unarchive_classroom": "Unarchive Classroom",
  "unarchive_classroom_confirmation": "Are you sure you want to unarchive this classroom?",
  "confirmArchiveText": "To confirm archiving, type 'archive' into the field below",
  "confirmUnarchiveText": "To confirm unarchiving, type 'unarchive' into the field below",
  "generate_bot": "Generate Chatbot",
  "generating_bot": "Generating Chatbot",
  "choose_topic_for_bot": "What would you like this chatbot to be about?",
  "use_context_from_topic_phrases": "Use topic phrases",
  "generate_bot_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "voice_speed": "Voice Speed",
  "phrase_to_speak": "Phrase to Speak",
  "voice_speed_extra_slow": "Extra Slow",
  "voice_speed_slow": "Slow",
  "voice_speed_medium": "Medium",
  "voice_speed_fast": "Fast",
  "voice_speed_extra_fast": "Extra Fast",
  "play_audio": "Play Audio",
  "generate_audio": "Generate Audio",
  "topic_goal": "Communicative goal",
  "topic_goal_info_text": "What do you want the learner to be able to do at the end of this lesson?",
  "archived_classrooms_title": "No Archived Classrooms",
  "archived_classrooms_desc": "When you're finished with a classroom, you can archive it. This will archive the classroom for all students and collaborators.",
  "bot_created": "Chatbot Created",
  "bot_deleted": "Chatbot Deleted",
  "ukrainian": "Ukrainien",
  "arabic": "Arabic",
  "chinese_simplified": "Chinese Simplified",
  "chinese_traditional": "Chinese Traditional",
  "czech": "Czech",
  "danish": "Danish",
  "dutch": "Dutch",
  "filipino": "Filipino",
  "greek": "Greek",
  "hindi": "Hindi",
  "hungarian": "Hungarian",
  "indonesian": "Indonesian",
  "japanese": "Japanese",
  "korean": "Korean",
  "malay": "Malay",
  "polish": "Polish",
  "punjabi": "Punjabi",
  "romanian": "Romanian",
  "swahili": "Swahili",
  "thai": "Thai",
  "turkish": "Turkish",
  "vietnamese": "Vietnamese",
  "speak_disabled": "Speak disabled",
  "move_message": "Move Message",
  "move_question": "Move Question",
  "topic_goal_placeholder": "e.g I can ask and answer questions about my identity.",
  "download_csv_template": "Download CSV Template",
  "upload_csv": "Upload CSV",
  "remove_csv": "Remove CSV",
  "single_phrase": "Single Phrase",
  "list_of_phrases": "List of Phrases",
  "text_studio": "Text-to-Speech Studio",
  "text_studio_description": "The Nualas are here to help you turn text into speech, select a language and choose from our selection of voices to bring your text to life.",
  "no_phrases_yet": "No phrases yet...",
  "access_denied_domain_unverified": "Access Denied: Domain Unverified",
  "file_name": "File Name",
  "download_audio": "Download Audio",
  "no_answer": "No Answer",
  "left_group": "Left Group",
  "view_feedback": "View Feedback",
  "no_feedback": "You have not given this student feedback yet",
  "app_search_placeholder": "Search community content",
  "delete_phrases": "Delete Phrases",
  "delete_phrases_confirmation": "Are you sure you want to delete the chosen phrases?",
  "share_audio": "Please uncheck this box if you do not want to share your audio with Nualang. Sharing the audio will help us diagnose the issue.",
  "edit_phrase": "Edit phrase",
  "share_screenshot": "Please check this box if you would like to share your screenshot with Nualang. Sharing the screenshot will help us diagnose the issue.",
  "screenshot_captured": "Screenshot captured:",
  "classroom_creator_play_live_game": "Play Nualang LIVE",
  "classroom_creator_play_live_game_desc": "Nualang LIVE offers customisable games that create a dynamic and engaging environment for students, allowing them to test their skills and compete against each other to win coveted Nuala medals.",
  "content_tags": "Add Tags",
  "enter_info_tags": "Enter a comma separated list of tags below.",
  "enter_collaborator_email": "Enter a comma or space separated list of email addresses below. Collaborators can manage courses, students, and classroom settings.",
  "enter_domains_info": "Enter a comma or space separated list of school domains below.",
  "search_error": "Une erreur s'est produite lors de la recherche, veuillez réessayer",
  "create_feedback_error": "Une erreur s'est produite lors de la création du retour, veuillez réessayer",
  "get_recs_error": "Une erreur s'est produite lors de l'obtention des enregistrements",
  "get_image_error": "Une erreur s'est produite lors de l'obtention des images",
  "update_discussion_error": "Une erreur s'est produite lors de la mise à jour de la discussion, veuillez réessayer",
  "invite_users_error": "Une erreur s'est produite lors de l'invitation des utilisateurs, veuillez réessayer",
  "create_image_error": "Une erreur s'est produite lors du téléchargement de l'image, veuillez réessayer",
  "grade_conversation_error": "Une erreur s'est produite lors de la notation de la conversation, veuillez réessayer",
  "get_transcript_error": "Une erreur s'est produite lors de l'obtention de la transcription, veuillez réessayer",
  "get_subs_error": "Une erreur s'est produite lors de l'obtention des soumissions, veuillez réessayer",
  "delete_picture_confirmation": "Are you sure you want to delete this picture?",
  "inappropriate_language_detected": "Inapproriate Language Detected",
  "schedule_discussion_error": "Une erreur s'est produite lors de la planification de la discussion, veuillez réessayer",
  "heritage_speaker": "Read/Write",
  "unmark_as_heritage_speaker": "Disable Read/Write Mode",
  "mark_as_heritage_speaker": "Enable Read/Write Mode",
  "heritage_speaker_desc": "Focuses on reading and writing by disabling listening and speaking where appropriate. Designed with heritage learners in mind.",
  "heritage_speaker_point_1": "The word bank will be disabled",
  "heritage_speaker_point_2": "Listening and pronunciation will be disabled where appropriate.",
  "freely_changed": "This can be freely changed at any time.",
  "generate_transcript": "Generate Transcript",
  "suggested_images": "Suggested Images",
  "mark_as_challenge_student": "Enable Challenge Mode",
  "unmark_as_challenge_student": "Disable Challenge Mode",
  "mark_as_challenge_bot": "Mark as Challenge Mode",
  "unmark_as_challenge_bot": "Unmark as Challenge Mode",
  "challenge_student": "Challenge Mode",
  "challenge_student_desc": "Unlocks chatbots that prompt extended responses and formal, academic language. Designed with heritage learners in mind.",
  "challenge_bot": "Challenge Mode",
  "challenge_bot_desc": "This chatbot is visible only to students with Challenge Mode enabled in the Students tab. Designed with heritage learners in mind, it provides formal, academic prompts.",
  "rewatch_tutorial": "Rewatch Tutorial",
  "heritage_speaker_progress": "Students marked as 'Read/Write' will have their learning experience adjusted to focus more on reading and writing.",
  "auto_generate_phrase_translation": "Generate Translations",
  "word_near_correct": "This word is correct, but it is in the wrong position",
  "partially_correct": "Partially Correct",
  "tag_info": "Tags help organize and categorize content, making it easier to find and group related materials. Use tags to improve the discoverability of your content and streamline your workflow.",
  "assignments": "Assignments",
  "assign_exercises": "Assign Exercises",
  "assign_exercises_desc": "Select activities from your curated library of content and assign them to your students with just a few clicks. Watch as they engage with exercises designed to reinforce learning, practice skills, and deepen understanding.",
  "assign_discuss": "Assign Discuss",
  "assign_discuss_desc": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "archive_discussions": "Archived Discussions",
  "archive_submissions": "Archived submissions",
  "assignment": "Assignment",
  "create_assignment": "Create Assignment",
  "no_assignments": "No Assignments",
  "assignments_description": "Assignments are a great way to engage your students with interactive content. Create assignments to reinforce learning, practice skills, and deepen understanding.",
  "no_assignments_desc": "There are no assignments in this classroom yet.",
  "select_classroom": "Select Classroom",
  "assignment_title": "Assignment Title",
  "assignment_description": "Assignment Description",
  "select_members": "Select Students",
  "schedule_assignment": "Schedule Assignment",
  "assign_date": "Available From",
  "add_exercise": "Add Exercise",
  "add_exercises": "Add Exercises",
  "assign_exercises_description": "Select exercises from your library to assign to your students",
  "due_in": "Due in",
  "due_tomorrow": "Due Tomorrow",
  "student_edited_transcript": "L'étudiant a modifié manuellement cette transcription après l'enregistrement.",
  "member_updated": "Student updated",
  "delete_assignment": "Delete Assignment",
  "delete_assignment_confirmation": "Are you sure you want to delete this assignment?",
  "assignment_deleted": "Assignment deleted",
  "assignment_created": "Assignment created",
  "assignees_created": "Assignees created",
  "classroom_creator_subscription_expired": "The creator's subscription has expired.",
  "return_to_classrooms": "Return to Classrooms",
  "creator_not_subscribed_upgrade_title": "Subscription Expired",
  "creator_not_subscribed_upgrade": "Your subscription has expired. Please upgrade plan in order to continue the following features:",
  "creator_not_subscribed_upgrade_description": "Student access to classroom activities.",
  "creator_not_subscribed_upgrade_description2": "Ability to create Nualang LIVE games",
  "creator_not_subscribed_upgrade_description3": "Student ability to join classroom.",
  "due_today": "Due Today",
  "update_assignment": "Update Assignment",
  "refresh_assignments": "Refresh Assignments",
  "report_type": "Type",
  "go_back_to_assignments": "Go back to Assignments",
  "available_today": "Available Today",
  "available_tomorrow": "Available Tomorrow",
  "available_in": "Available in",
  "not_assigned": "Not Assigned",
  "assigned": "Assigned",
  "view_assignment": "View Assignment",
  "no_assignments_description": "There are currenly no assignments created.",
  "no_shared_courses": "Il n'y a aucun cours partagé entre les salles de classe sélectionnées.",
  "view_submissions": "View Submissions",
  "archive": "Archive",
  "discussions": "Discussions",
  "generated_phrases": "Are you sure you want to add the following generated phrases to the list? These phrases will be appended and will not replace any existing phrases.",
  "everyone": "Everyone",
  "duplicate_course_confirmation": "This will make a copy of the course that you can edit. You won't get updates or changes from the original course.",
  "duplication": "Allow others to duplicate this course.",
  "invalid_email_format": "Invalid email format",
  "email_domain_mismatch_error": "Email must be from your domain ({{domain}}).",
  "generic_email_domain_error": "Generic email domain error",
  "duplicate_disabled_tooltip": "This course has been disabled for duplication by the creator.",
  "collaborators_only": "Collaborators",
  "hide_course": "Hide Course",
  "show_course": "Show Course",
  "default_assignment_title": "New Classroom Assignment",
  "default_assignment_instructions": "Please complete the tasks below before the due date.",
  "due": "Due",
  "hide_from_students": "Hide from Students",
  "show_to_students": "Show to Students",
  "hello": "Bonjour",
  "dynamic_response": "Dynamic Responses",
  "dynamic_response_desc": "Allow Chatbots in this Classroom to generate customized replies based on student input, powered by AI.",
  "assign_to": "Assign To",
  "all_students": "All Students",
  "ai_chatbot_message_info": "This chatbot message is generated using AI.",
  "ai_chatbot_message_generating_info": "This chatbot message is being generated using AI.",
  "language_correction": "Correction linguistique",
  "correction_original": "Original",
  "correction_suggested": "Suggestion",
  "language_corrections_to_review": "Corrections linguistiques à revoir",
  "dynamic_responses_info": "Enabling this feature allows the Chatbots to use AI to generate personalized responses based on what students say. While this can support more engaging learning, responses are automatically generated and may vary. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "paste_your_csv_data": "Paste your CSV data here",
  "user_level_settings": "Paramètres au niveau de l'utilisateur",
  "chatbot_dynamic_responses": "Chatbot - Réponses dynamiques",
  "chatbot_dynamic_responses_desc": "Si la réponse dynamique est activée, le Chatbot écoutera et s'adaptera activement, en demandant plus de détails, une formulation plus claire ou des réponses réalistes, au lieu de simplement passer à l'invite suivante prédéfinie.",
  "chatbot_now_ai": "Nualang Chatbot: Now with Real-Time Feedback",
  "chatbot_now_ai_desc": "More speaking support. Same structure. No extra work. Students now get helpful, AI-enhanced feedback as they chat!",
  "chatbot_now_ai_revert_settings": "You can limit AI anytime in your ",
  "prefer_original_version": "Prefer the original version?",
  "chatbot_now_ai_benefit": "It’s like giving every student a conversation coach built right into the activity—with zero extra prep or grading.",
  "ai_learn_more": "Want to learn more? Read our approach to AI safety and trust.",
  "ai_settings_desc": "Choose which AI features are available in this classroom.",
  "limit_ai": "AI in this classroom",
  "limit_ai_desc": "Allow the AI features below in this classroom or disable them entirely.",
  "limit_ai_info": "Disabling AI in this classroom turns off each AI feature below at once: Chatbot dynamic responses and AI-generated feedback on Discuss recordings. Teachers can still write and submit their own feedback. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "limit_ai_course_desc": "Turn chatbot dynamic responses off for this course only. The classroom setting applies unless you change it here.",
  "chatbot_ai": "Chatbot - Dynamic Responses",
  "chatbot_ai_desc": "Allow AI to generate feedback and responses to students or disable to use scripted replies.",
  "discuss_ai": "Discuss - AI feedback",
  "discuss_ai_desc": "Allow AI to generate draft feedback on student submissions or disable to require teacher created feedback only.",
  "ai_allowed": "Enabled",
  "ai_limited": "Disabled",
  "ai_limited_classroom_notice": "AI is disabled in this classroom, the features below are unavailable.",
  "ai_locked_notice": "AI is limited for your whole organization, so it cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_partly_locked_notice": "Some AI features are limited for your whole organization, so they cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_overview_desc": "AI settings for every classroom you teach, including ones you co-teach. Changes apply to the classroom straight away.",
  "ai_overview_empty": "You don't teach any classrooms yet.",
  "ai_overview_load_failed": "Your classrooms could not be loaded. Please try again.",
  "ai_overview_save_failed": "This change could not be saved",
  "ai_overview_apply_all": "Apply to all",
  "ai_overview_enable_all": "Enable for all classrooms",
  "ai_overview_disable_all": "Disable for all classrooms",
  "ai_overview_apply_all_count": "Classrooms that will change",
  "ai_overview_apply_all_skips": "Archived classrooms, and settings fixed by your organization, are not changed.",
  "ai_overview_apply_all_saved": "Classrooms updated",
  "ai_overview_apply_all_failed": "These classrooms could not be updated",
  "ai_overview_course_overrides": "Courses with the chatbot disabled",
  "ai_overview_open_classroom": "Classroom settings",
  "ai_overview_no_active": "All your classrooms are archived.",
  "ai_course_overrides_notice": "Allowed for this classroom, but disabled for these courses",
  "ai_per_course_hint": "You can also limit chatbot dynamic responses for individual courses in Course settings below.",
  "ai_limited_feedback_blocked": "AI is limited for this classroom, so AI feedback cannot be generated.",
  "ai_settings": "AI Settings",
  "student_sent_inappropriate_messages": "La transcription ci-dessous nécessite votre révision.",
  "challenge_mode": "Challenge Mode",
  "student_misuse_reported": "Student Misuse Reported",
  "student_acts_inappropriately": "Un étudiant agit de manière inappropriée pendant un exercice avec le Chatbot",
  "ai_chatbot_error_response": "Désolé, j'ai fait une erreur dans ma réponse. Veuillez réessayer !",
  "no_members_tooltip": "Cannot perform this action because there are no students or courses in this classroom.",
  "overdue": "Overdue",
  "due_next": "Due Next",
  "active": "Active",
  "archived": "Archived",
  "past_due": "Past Due",
  "available_from": "Available from",
  "roleplay-fill-in-the-blanks": "Scenario fill in the blanks",
  "roleplay-act-it-out": "Scenario act it out",
  "roleplay-act-it-out-listening": "Scenario act it out listening",
  "roleplay-act-it-out-speaking": "Scenario act it out speaking",
  "roleplay-act-it-out-listening-speaking": "Scenario act it out listening and speaking",
  "generate_discussion": "Generate Discussion",
  "generating_discussion": "Generating Discussion",
  "discuss_prompt_language": "Choose a language for the discussion prompt",
  "level": "Level",
  "grouped_discussion": "Grouped Discussion",
  "not_present": "Was not present for the discussion",
  "view_recording": "View Recording",
  "generate_feedback": "Generate Feedback",
  "generate_feedback_for_all": "Generate Feedback for All",
  "performance_rating": "Performance Rating",
  "feedback_submitted": "Feedback Submitted",
  "group_not_submitted": "Group has not submitted a recording yet",
  "this_classroom_is_archived": "This classroom is archived",
  "submission_graded": "Submission Graded",
  "view_submission": "View Submission",
  "show_more": "Show more",
  "show_less": "Show less",
  "submit_feedback_confirmation": "Have you reviewed all generated feedback and are you ready to submit it to students?",
  "submit_feedback_scroll": "Review all feedback before submitting it to students",
  "ai_draft_not_edited": "AI draft, not edited",
  "edited_by_you": "Edited by you",
  "approved": "Approved",
  "approve": "Approve",
  "undo": "Undo",
  "x_of_n": "{{x}} of {{n}}",
  "ai_drafts_reviewed": "AI drafts reviewed",
  "approve_ai_drafts_to_submit_one": "Approve {{count}} AI draft to submit",
  "approve_ai_drafts_to_submit_other": "Approve {{count}} AI drafts to submit",
  "ai_suggested": "AI-suggested",
  "ai_suggested_tooltip": "Your teacher used AI to draft this feedback and sent it to you.",
  "course_topic": "Course Topic",
  "discussion_topic_helper": "Select a relevant topic to help generate the discussion.",
  "no_groups_created_yet": "No groups created yet",
  "select_students_from_the_list": "Select students from the list on the left to create a group",
  "drop_members_here": "Drop students here to create a group",
  "drag_a_student_here": "Drag a student here to create a group",
  "new_group": "New Group",
  "cannot_edit_discussion": "Cannot edit discussion with existing submissions",
  "generating_feedback": "Generating Feedback",
  "conversations_graded_success": "Feedback Generated",
  "below_level": "Below Level",
  "at_level": "At Level",
  "above_level": "Above Level",
  "ai_performance_assessment": "AI Performance Assessment",
  "performance_chip_tooltip": "Indicates how a student’s performance compares to the expected proficiency range, based on AI analysis.",
  "performance_chip_note": "Visible only to teachers and intended to support instructional review.",
  "you_are_human": "Si vous êtes humain, laissez ce champ vide",
  "progress": "Progress",
  "no_scheduled_assignments": "No Scheduled Assignments",
  "no_past_due_assignments": "No Past Due Assignments",
  "no_past_due_discussions": "No Past Due Discussions",
  "no_archived_discussions": "No Archived Discussions",
  "no_discussions": "No Discussions",
  "no_discussions_description": "Discussions are a great way to engage your students with collaborative conversations. Create discussions to practice speaking, build confidence, and develop communication skills.",
  "meaning": "Meaning",
  "meaning_exercise_desc": "Match definitions to the correct phrase.",
  "meaning-listen-and-speak": "Signification - Écouter et Parler",
  "meaning_listen_and_speak_exercise_desc": "Écoutez la définition et parlez la phrase correspondante.",
  "meaning-read-and-write": "Signification - Lire et Écrire",
  "select_the_correct_phrase": "Sélectionnez la bonne phrase pour cette définition",
  "chinese": "Chinois",
  "custom_feedback_placeholder": "Optionnel : ajoutez des instructions supplémentaires pour orienter le retour (par ex. précision, complexité ou utilisation des structures cibles).",
  "generate_feedback_view_the": "Voir la",
  "generate_feedback_rubric_name": "Grille d’évaluation de croissance analytique",
  "generate_feedback_rubric_desc": "les critères utilisés dans nos retours d’information IA.",
  "late_submission": "Soumission en Retard",
  "days_late_one": "{{count}} jour de retard",
  "days_late_other": "{{count}} jours de retard",
  "phrase_definition": "Définition de la phrase",
  "phrase_definition_helper_text": "Appuyez sur la touche Entrée / Retour pour ajouter une définition.",
  "generate_definitions": "Générer des définitions",
  "phrases_exercise_desc": "Practice key phrases you'll use in conversations.",
  "phrase_group_name": "Phrase List Name",
  "create_phrase_group": "Create Phrase List",
  "preview_phrases": "Preview Phrases",
  "show_keyboard": "Show Keyboard",
  "hide_exercise": "Hide Exercise",
  "phrase_list": "Phrase List",
  "phrase_lists": "Listes de phrases",
  "no_phrase_lists": "Aucune liste de phrases",
  "all_phrase_lists": "Toutes les listes de phrases",
  "edit_phrase_list": "Edit Phrase List",
  "hide_phrase_list": "Hide Phrase List",
  "move_phrase_list": "Move Phrase List",
  "remove_phrase_list": "Remove Phrase List",
  "show_exercise": "Show Exercise",
  "hide_keyboard": "Hide Keyboard",
  "editor": "Editor",
  "phrase_list_name": "Phrase List Name",
  "phrase_list_information": "Phrase List Information",
  "build_meaning": "Build Meaning",
  "read_and_write": "Read & Write",
  "meaning_listen_and_speak": "Listen & Speak",
  "hide_phrases_exercise": "Hide Phrases",
  "show_phrases_ecercise": "Show Phrases",
  "generate_defintions_error": "Un problème est survenu lors de la génération des définitions. Veuillez réessayer.",
  "saving_defintions_error": "Un problème est survenu lors de l’enregistrement des définitions. Veuillez réessayer.",
  "auto_generate_definitions": "Générer des Définitions",
  "generating_definitions": "Génération des définitions",
  "definitions": "Définitions",
  "view_phrase_list": "Voir la liste des phrases",
  "meaning_exercise_welcome": "Welcome to the Meaning Exercise",
  "meaning_exercise_definition": "Definition",
  "meaning_exercise_definition_desc": "Select the correct word or phrase based on the definition",
  "meaning_exercise_options": "Options",
  "meaning_exercise_options_desc": "Select the correct options for this sentence",
  "meaning_no_definitions": "This phrase list has no definitions",
  "definition": "Definition",
  "review_generated_definitions": "Review Generated Definitions",
  "new_definitions": "New Definition",
  "current_definitions": "Current Definition",
  "play_phrase_list": "Play Phrase List",
  "transfer_phrases": "Copier vers",
  "transfer": "Copier",
  "create_phrase_list_from_selection": "Créer une nouvelle liste de phrases",
  "no_other_phrase_lists": "Aucune autre liste de phrases",
  "add_row": "Ajouter une ligne",
  "problem_updating": "Un problème est survenu lors de la mise à jour",
  "exercise_settings": "Paramètres des exercices",
  "excercise_voice": "Voix de l'exercice",
  "excercise_voice_desc": "Sélectionnez la voix qui sera utilisée dans les exercices de cette liste de phrases.",
  "excercise_visibility": "Visibilité des exercices",
  "keyboard": "Clavier",
  "legacy_voice_tooltip_text": "Older voice technology. May sound less natural.",
  "listen_and_speak_exercise_desc": "Listen to the definition. Say the phrase.",
  "identify_this_phrase": "Identify this phrase",
  "play_phrase": "Play Phrase",
  "listen_and_speak_exercise_welcome": "Getting started with the Listen & Speak Exercise",
  "listen_and_speak_exercise_speak_desc": "Click to listen to how the definition",
  "listen_and_speak_exercise_listen": "Listen to the definition!",
  "listen_and_speak_exercise_voice_input": "Pronounce the phrase that matches the definition",
  "hide_phrase_image": "Hide phrase image",
  "show_phrase_image": "Show phrase image",
  "read_write_exercise_welcome": "Bienvenue dans l'exercice Lire et Écrire",
  "read_write_exercise_definition": "Définition",
  "read_write_exercise_definition_desc": "Lisez la définition affichée ici",
  "read_write_exercise_options": "Tapez la phrase",
  "read_write_exercise_options_desc": "Tapez la phrase correcte dans la zone de texte",
  "read_the_definition": "Lisez la définition",
  "type_the_correct_phrase": "Tapez la phrase correcte",
  "read_write": "Lire et Écrire",
  "meaning_read_write": "Signification - Lire et Écrire",
  "meaning_read_write_exercise_desc": "Lisez la définition et tapez la phrase correcte.",
  "course_description_default": "This is a course to help students speak {{learnLang}} with confidence.",
  "image_builder": "Image Builder",
  "background_color": "Background Color",
  "icon": "Icon",
  "pattern_density": "Pattern Density",
  "use_image": "Use Image",
  "background_colour": "Background Colour",
  "icon_opacity": "Icon Opacity",
  "custom_colour": "Custom Colour",
  "create_chatbot": "Créer un chatbot",
  "find_chatbot": "Trouver un chatbot",
  "find_chatbots": "Trouver des chatbots",
  "add_chatbot": "Ajouter un chatbot",
  "add_chatbots": "Ajouter des chatbots",
  "template": "Modèle",
  "chatbot_name": "Nom du chatbot",
  "create_scenario": "Créer un jeu de rôle",
  "find_scenario": "Trouver un jeu de rôle",
  "find_scenarios": "Trouver des jeux de rôle",
  "scenario_name": "Nom du jeu de rôle",
  "scenarios_added": "Jeux de rôle ajoutés au sujet",
  "chatbots_added": "Chatbots ajoutés au sujet",
  "add_scenarios": "Ajouter des jeux de rôle",
  "achievements": "Réalisations",
  "topic_description_default": "This is a topic to help students speak {{learnLang}} with confidence.",
  "selected_topics": "Selected Topics",
  "no_topics_selected": "No topics selected",
  "add_topics": "Add topics",
  "find_topics": "Find topics",
  "find_topic": "Find Topic",
  "no_topics_found": "No topics found",
  "no_library_topics_community_hint": "Trouvez des sujets créés par d'autres enseignants dans l'onglet <1>Communauté</1>.",
  "chatbot_title": "Titre du chatbot",
  "open_ended": "Ouvert terminé",
  "open_ended_desc": "Laissez vos élèves répondre avec leurs propres mots.",
  "quiz": "Quiz",
  "quiz_desc": "Guidez l'étudiant à travers une série de questions.",
  "picture_quiz": "Quiz Photo",
  "picture_quiz_desc": "Posez des questions basées sur des images.",
  "emoji_quiz": "Emoji Quiz",
  "emoji_quiz_desc": "Devinez la réponse basée sur les emojis.",
  "quiz_style_templates": "Modèles de type quiz",
  "no_scenarios_found": "Aucun jeu de rôle trouvé",
  "no_chatbots_found": "Aucun chatbot trouvé",
  "use_voice": "Utiliser la voix",
  "internal_view_provider_marks": "Vue interne · Notes du fournisseur visibles",
  "legacy": "Ancien",
  "scan_to_open_the_classroom": "Scannez pour ouvrir la classe",
  "classroom_link": "Lien de la classe",
  "copy": "Copier",
  "tell_students_to": "Dites aux élèves de :",
  "invite_step_sign_in": "Se connecter à leur compte.",
  "invite_step_scan": "Scanner le code ou ouvrir la classe.",
  "invite_step_tap_join": "Appuyer sur {{button}}.",
  "select_exercise_phrases_intro": "Cochez les listes de phrases à utiliser dans le jeu. Vous pouvez combiner des listes de différents cours.",
  "select_exercise_scenarios_intro": "Choisissez un scénario à jouer en direct avec la classe.",
  "source_type_phrase_lists": "Listes de phrases",
  "source_type_scenarios": "Scénarios",
  "clear_all": "Tout effacer",
  "n_of_m_lists_selected": "{{n}} sur {{m}} listes sélectionnées",
  "n_phrase_lists": "{{count}} listes de phrases",
  "n_phrases": "{{count}} phrases",
  "has_definitions": "avec définitions",
  "n_scenarios": "{{count}} scénarios",
  "n_messages": "{{count}} messages",
  "n_interactions": "{{count}} interactions",
  "lists_and_phrases_selected": "{{lists}} listes · {{phrases}} phrases",
  "no_lists_selected": "Aucune liste sélectionnée",
  "no_scenario_selected": "Aucun scénario sélectionné",
  "scenario_selected": "Scénario sélectionné",
  "number_of_messages": "Nombre de messages",
  "max_phrases_label": "Max",
  "max_phrases_all": "Toutes les {{count}}",
  "estimated_game_time_hint": "{{questions}} questions à {{seconds}} s chacune, plus les retours entre les manches.",
  "n_minutes": "{{count}} minutes",
  "live_game_title": "{{exercise}} · {{count}} listes de phrases",
  "phrases_from": "Phrases de",
  "source_card_meta": "{{topic}} · {{count}} phrases",
  "n_more": "de plus",
  "waiting_for_students": "En attente des élèves.",
  "how_students_answer": "Comment les élèves répondent",
  "answer_keyboard_and_word_bank": "Clavier et banque de mots",
  "answer_keyboard_and_word_bank_hint": "Les élèves écrivent, avec la banque de mots en secours.",
  "answer_keyboard_only": "Clavier uniquement",
  "answer_keyboard_only_hint": "Le plus difficile — les élèves écrivent toute la réponse.",
  "answer_word_bank_only": "Banque de mots uniquement",
  "answer_word_bank_only_hint": "Le plus facile — les élèves appuient sur les mots pour les placer.",
  "time_per_question": "Temps par question",
  "all_n_phrases": "Toutes les {{count}} phrases",
  "includes_one_from_each_list": "Au moins une phrase de chaque liste sélectionnée est toujours incluse.",
  "chatbot": "Chatbot",
  "scenario": "Scenario",
  "conversation": "Conversation",
  "from_course": "From course",
  "from_course_named": "From course: {{title}}",
  "start_topic": "Start topic",
  "start_chat": "Start chat",
  "start_scenario": "Start scenario",
  "n_activities": "{{number}} activities",
  "roleplay_turns": "Roleplay · {{number}} turns",
  "filter_by_type": "Filter by type",
  "view_course_named": "View {{title}}",
  "show": "Show",
  "content_type": "Content type",
  "all_content": "all content",
  "results_summary": "{{number}} results for “{{query}}” · {{types}}",
  "n_results_named": "{{label}}, {{number}} results",
  "view_chatbot": "View chatbot",
  "view_scenario": "View scenario",
  "all_languages": "Toutes les langues",
  "all_levels": "Tous les niveaux",
  "novice": "Débutant",
  "intermediate": "Intermédiaire",
  "advanced": "Avancé",
  "popular": "Populaire",
  "courses_shared_by_other_teachers": "Cours partagés par d'autres enseignants",
  "no_created_courses_match": "Aucun cours créé ne correspond à ces filtres",
  "no_joined_courses_match": "Aucun cours suivi ne correspond à ces filtres",
  "no_community_courses_match": "Aucun cours ne correspond à ces filtres",
  "courses_added": "Cours ajoutés",
  "problem_adding_courses": "Il y avait un problème lors de l'ajout de ces cours",
  "search_topics_placeholder": "Rechercher des sujets",
  "search_classrooms_placeholder": "Rechercher des classes",
  "search_student_name": "Rechercher le nom de l'élève",
  "search_sections_and_topics": "Rechercher des sections et des thèmes",
  "clear_search": "Effacer la recherche",
  "x_of_y": "{{shown}} sur {{total}}",
  "outline_filter_count": "{{topics}} dans {{sections}}",
  "topic_count_one": "{{count}} thème",
  "topic_count_other": "{{count}} thèmes",
  "section_count_one": "{{count}} section",
  "section_count_other": "{{count}} sections",
  "no_sections_or_topics_match": "Aucune section ni aucun thème ne correspond",
  "try_different_keyword_or_difficulty": "Essayez un autre mot-clé ou une autre difficulté.",
  "nothing_matches_keyword_at_difficulty": "Aucun résultat pour « {{keyword}} » avec la difficulté {{difficulty}}. Essayez un autre mot-clé ou une autre difficulté.",
  "session_feedback": "Ton retour",
  "session_feedback_preparing": "Préparation de ton retour…",
  "session_feedback_unavailable": "Ton retour n'est pas disponible pour le moment.",
  "suggested_level": "Niveau suggéré",
  "session_report": "Retour sur la conversation",
  "view_full_report": "Voir le retour complet",
  "rating_approaching": "En progression",
  "rating_meets": "Atteint",
  "rating_exceeds": "Dépasse",
  "area_of_strength": "Point fort",
  "area_for_growth": "Axe de progrès",
  "rating_not_yet": "Pas encore",
  "session_report_short_interaction": "Interaction",
  "session_report_short_vocabulary": "Vocabulaire",
  "session_report_short_function": "Fonction",
  "session_report_strength": "Point fort",
  "session_report_growth": "Progrès",
  "ai_generated_report": "Retour généré par l'IA",
  "ai_generated_report_tooltip": "Généré par l'IA à partir de cette séance uniquement. Le niveau suggéré et les évaluations sont des estimations, pas un classement définitif.",
  "session_report_new": "Nouveau",
  "chatbot_mode_name": "Chatbot - {{mode}}",
  "chatbot_message_count": "{{count}} messages",
  "chatbot_message_count_one": "{{count}} message",
  "chatbot_message_count_other": "{{count}} messages",
  "attempt_count": "{{count}} tentatives",
  "attempt_count_one": "{{count}} tentative",
  "attempt_count_other": "{{count}} tentatives",
  "of_total_correct": "sur {{total}} correctes",
  "attempts_to_review": "Tentatives à revoir",
  "attempts_not_shown": "{{items, list}} : tentatives non affichées",
  "count_correct": "{{count}} correctes",
  "count_incorrect": "{{count}} incorrectes",
  "count_skipped": "{{count}} ignorées",
  "count_partially_correct": "{{count}} partiellement correctes",
  "view_all_count": "Voir les {{count}}",
  "view_attempt": "Voir la tentative",
  "scenario_description_default": "Ce scénario aide les élèves à parler {{learnLang}} avec assurance."
}
